import {
    g as P,
    S as j,
    a as he,
    F as $e
} from "./pieces-gsap.js";
import {
    L as Me
} from "./pieces-lenis.js";
import {
    e as Pt,
    l as xe,
    s as It,
    h as Ze,
    _ as $t,
    a as Mt,
    i as Ot,
    b as Dt,
    o as zt,
    r as Ht
} from "./pieces-swup.js";
P.registerPlugin(j);
class Nt {
    constructor() {
        this.lenis = null, this.isInitialized = !1
    }
    init() {
        return this.isInitialized ? this.lenis : (this.lenis = new Me({
            duration: 1.2,
            easing: t => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            orientation: "vertical",
            gestureOrientation: "vertical",
            smoothWheel: !0,
            wheelMultiplier: 1,
            touchMultiplier: 2,
            infinite: !1,
            prevent: t => t.closest(".cart-drawer__content") || t.closest(".mobile-nav__content") || t.closest("[data-lenis-prevent]")
        }), this.lenis.on("scroll", j.update), P.ticker.add(t => {
            this.lenis.raf(t * 1e3)
        }), P.ticker.lagSmoothing(0), document.documentElement.classList.add("lenis"), this.isInitialized = !0, this.lenis)
    }
    scrollTo(t, i = {}) {
        if (!this.lenis) return;
        const s = {
            offset: 0,
            duration: 1.2,
            easing: o => Math.min(1, 1.001 - Math.pow(2, -10 * o)),
            immediate: !1,
            lock: !1,
            onComplete: null
        };
        this.lenis.scrollTo(t, {
            ...s,
            ...i
        })
    }
    stop() {
        this.lenis && this.lenis.stop()
    }
    start() {
        this.lenis && this.lenis.start()
    }
    resize() {
        this.lenis && this.lenis.resize()
    }
    destroy() {
        this.lenis && (this.lenis.destroy(), this.lenis = null, this.isInitialized = !1, document.documentElement.classList.remove("lenis"))
    }
    get scroll() {
        return this.lenis?.scroll || 0
    }
    get progress() {
        return this.lenis?.progress || 0
    }
    get isScrolling() {
        return this.lenis?.isScrolling || !1
    }
}
const U = new Nt;

function oe() {
    return oe = Object.assign ? Object.assign.bind() : function(d) {
        for (var t = 1; t < arguments.length; t++) {
            var i = arguments[t];
            for (var s in i)({}).hasOwnProperty.call(i, s) && (d[s] = i[s])
        }
        return d
    }, oe.apply(null, arguments)
}
window.process || (window.process = {}), window.process.env || (window.process.env = {});
const st = ["test"].includes("production"),
    O = ["development", "test"].includes("production"),
    rt = (d, t, i) => d == null ? d : `\x1B[${t}m${String(d)}\x1B[${i}m`,
    Le = d => st ? d : `🧩 ${(t=>rt(t,1,22))(d)}`,
    F = d => st ? d : (t => rt(t, 94, 39))(d);
class Ft {
    log(...t) {
        const i = t.shift();
        console.log(Le(i), ...t)
    }
    warn(...t) {
        const i = t.shift();
        console.warn(Le(i), ...t)
    }
    error(...t) {
        const i = t.shift();
        console.error(Le(i), ...t)
    }
    logIf(t, ...i) {
        t && this.log(...i)
    }
    warnIf(t, ...i) {
        t && this.warn(...i)
    }
    errorIf(t, ...i) {
        t && this.error(...i)
    }
}
const at = d => {
        (function({
            parsedRules: t,
            swup: i,
            logger: s
        }) {
            const o = i.getCurrentUrl();
            t.filter(c => c.matchesFrom(o) || c.matchesTo(o)).forEach(c => {
                c.containers.forEach(f => {
                    const g = Ee(`${f}:not([data-swup-fragment])`, i);
                    if (!g) return;
                    const v = g.getAttribute("data-swup-fragment-url");
                    v && O && s?.log(`fragment url ${F(v)} for ${F(f)} provided by server`);
                    const {
                        url: m
                    } = xe.fromUrl(v || o);
                    g.setAttribute("data-swup-fragment", ""), g.__swupFragment = {
                        url: m,
                        selector: f
                    }
                })
            })
        })(d), (function({
            logger: t,
            swup: i
        }) {
            const s = "data-swup-link-to-fragment";
            document.querySelectorAll(`a[${s}]`).forEach(o => {
                var c, f;
                const g = (c = o.getAttribute(s)) == null ? void 0 : c.trim();
                if (!g) return void(O && (t == null || t.warn(`[${s}] needs to contain a valid fragment selector`)));
                const v = g.trim().split(",").map(S => S.trim()),
                    m = (function(S, w) {
                        const x = S.map(C => C.trim());
                        for (const C of x) {
                            const L = Ee(C, w);
                            if (L) return L
                        }
                    })(v, i);
                if (!m) {
                    if (O) {
                        const S = v.length > 1 ? "are" : "is",
                            w = F(v.join(", "));
                        t?.log(`ignoring ${F(`[${s}="${g}"]`)} as ${w} ${S} missing`)
                    }
                    return
                }
                const k = (f = m.__swupFragment) == null ? void 0 : f.url;
                k ? (Oe(k, i.getCurrentUrl()) && O && t?.warn(`The fragment URL of #${m.id} is identical to the current URL. This could mean that [data-swup-fragment-url] needs to be provided by the server.`), o.href = k) : O && t?.warn(`no fragment infos found on #${m.id}`)
            })
        })(d), (function({
            logger: t
        }) {
            document.querySelectorAll("dialog[data-swup-fragment][open]").forEach(i => {
                i.__swupFragment ? i.__swupFragment.modalShown || (i.__swupFragment.modalShown = !0, i.removeAttribute("open"), i.showModal == null || i.showModal(), i.addEventListener("keydown", s => s.key === "Escape" && s.preventDefault())) : O && t?.warn("fragment properties missing on element:", i)
            })
        })(d)
    },
    Pe = (d, t) => {
        var i;
        const s = (i = d.__swupFragment) == null ? void 0 : i.url;
        return !!s && Oe(s, t)
    },
    Oe = (d, t) => Qe(d) === Qe(t),
    Qe = d => {
        if (!d.trim()) return d;
        const t = xe.fromUrl(d);
        return t.searchParams.sort(), t.pathname.replace(/\/+$/g, "") + t.search
    },
    ot = d => {
        const t = d.from.url,
            i = d.to.url;
        if (t && i) return {
            from: t,
            to: i
        }
    },
    De = (d, t) => {
        if (d == null || !d.name) return;
        const {
            name: i,
            containers: s
        } = d;
        s.forEach(o => {
            var c;
            (c = document.querySelector(o)) == null || c.classList.toggle(`to-${i}`, t)
        })
    },
    lt = (d, t, i) => t.find(s => s.matches(d, i));

function ct(d) {
    return !!d && d.containers.every(t => {
        var i;
        return ((i = document.querySelector(t)) == null || (i = i.tagName) == null ? void 0 : i.toLowerCase()) === "template"
    })
}

function Ee(d, t) {
    for (const i of t.options.containers) {
        const s = document.querySelector(i);
        if (s != null && s.matches(d)) return s;
        const o = s?.querySelector(d);
        if (o) return o
    }
}

function Je(d) {
    if (!Array.isArray(d)) throw new Error("cloneRules() expects an array of rules");
    return d.map(t => oe({}, t, {
        from: Array.isArray(t.from) ? [...t.from] : t.from,
        to: Array.isArray(t.to) ? [...t.to] : t.to,
        containers: [...t.containers]
    }))
}
class Bt {
    constructor(t) {
        var i, s;
        this.matchesFrom = void 0, this.matchesTo = void 0, this.swup = void 0, this.from = void 0, this.to = void 0, this.containers = void 0, this.name = void 0, this.scroll = !1, this.focus = void 0, this.logger = void 0, this.if = () => !0, this.swup = t.swup, this.logger = t.logger, this.from = t.from || "", this.to = t.to || "", t.name && (this.name = It(t.name)), t.scroll !== void 0 && (this.scroll = t.scroll), t.focus !== void 0 && (this.focus = t.focus), typeof t.if == "function" && (this.if = t.if), this.containers = this.parseContainers(t.containers), O && ((i = this.logger) == null || i.errorIf(!this.to, "Every fragment rule must contain a 'to' path", this), (s = this.logger) == null || s.errorIf(!this.from, "Every fragment rule must contain a 'from' path", this)), this.matchesFrom = Ze(this.from), this.matchesTo = Ze(this.to)
    }
    parseContainers(t) {
        var i, s;
        return Array.isArray(t) && t.length ? (s = t.map(o => o.trim()), [...new Set(s)]).filter(o => {
            var c;
            const f = this.validateSelector(o);
            return (c = this.logger) == null || c.errorIf(f instanceof Error, f), f === !0
        }) : (O && ((i = this.logger) == null || i.error("Every fragment rule must contain an array of containers", this.getDebugInfo())), [])
    }
    validateSelector(t) {
        return t.startsWith("#") ? !t.match(/\s|>/) || new Error(`fragment selectors must not be nested: ${t}`) : new Error(`fragment selectors must be IDs: ${t}`)
    }
    getDebugInfo() {
        const {
            from: t,
            to: i,
            containers: s
        } = this;
        return {
            from: String(t),
            to: String(i),
            containers: String(s)
        }
    }
    matches(t, i) {
        var s;
        if (!this.if(i)) return O && ((s = this.logger) == null || s.log("ignoring fragment rule due to custom rule.if:", this)), !1;
        const {
            url: o
        } = xe.fromUrl(t.from), {
            url: c
        } = xe.fromUrl(t.to);
        if (!this.matchesFrom(o) || !this.matchesTo(c)) return !1;
        for (const g of this.containers) {
            const v = this.validateFragmentSelectorForMatch(g);
            var f;
            if (v instanceof Error) return O && ((f = this.logger) == null || f.error(v, this.getDebugInfo())), !1
        }
        return !0
    }
    validateFragmentSelectorForMatch(t) {
        return document.querySelector(t) ? !!Ee(t, this.swup) || new Error(`skipping rule since ${F(t)} is outside of swup's default containers`) : new Error(`skipping rule since ${F(t)} doesn't exist in the current document`)
    }
}
const Yt = function(d) {
        const t = ot(d);
        t && lt(t, this.parsedRules, d) && (d.scroll.reset = !1)
    },
    Rt = async function(d) {
        const t = ot(d);
        if (!t) return;
        const i = this.getFragmentVisit(t, d);
        if (!i) return;
        var s;
        d.fragmentVisit = i, O && ((s = this.logger) == null || s.log(`fragment visit: ${F(d.fragmentVisit.containers.join(", "))}`)), d.scroll = (function(f, g) {
            return typeof f.scroll == "boolean" ? oe({}, g, {
                reset: f.scroll
            }) : typeof f.scroll != "string" || g.target ? g : oe({}, g, {
                target: f.scroll
            })
        })(i, d.scroll);
        const o = d.a11y;
        var c;
        i.focus !== void 0 && (O && ((c = this.logger) == null || c.errorIf(!o, "Can't set visit.a11y.focus. Is @swup/a11y-plugin installed?")), o && (o.focus = i.focus)), d.animation.scope = d.fragmentVisit.containers, d.containers = d.fragmentVisit.containers, d.animation.selector = d.fragmentVisit.containers.join(","), De(i, !0)
    }, Xt = function(d, t) {
        var i, s;
        d.fragmentVisit && ct(d.fragmentVisit) && (O && ((i = this.logger) == null || i.log(`${F("out")}-animation skipped for ${F((s=d.fragmentVisit)==null?void 0:s.containers.toString())}`)), t.skip = !0)
    }, Vt = function(d, t) {
        var i, s;
        d.fragmentVisit && ct(d.fragmentVisit) && (O && ((i = this.logger) == null || i.log(`${F("in")}-animation skipped for ${F((s=d.fragmentVisit)==null?void 0:s.containers.toString())}`)), t.skip = !0)
    }, jt = function(d, t) {
        var i;
        if (d.trigger.el || !d.to.url) return;
        const s = this.swup.cache.get(d.to.url);
        s && s.fragmentHtml && (d.to.document = new DOMParser().parseFromString(s.fragmentHtml, "text/html"), d.to.html = s.fragmentHtml, O && ((i = this.logger) == null || i.log(`fragment cache used for ${F(d.to.url)}`)))
    }, Wt = function(d) {
        De(d.fragmentVisit, !0), at(this), (({
            swup: t,
            logger: i
        }) => {
            const s = t.getCurrentUrl(),
                o = t.cache,
                c = o.get(s);
            if (!c) return;
            const f = new DOMParser().parseFromString(c.html, "text/html"),
                g = [],
                v = Array.from(document.querySelectorAll("[data-swup-fragment]")).filter(m => !m.matches("template") && !Pe(m, s));
            v.length && (t.options.cache ? (v.forEach(m => {
                var k, S;
                if (m.querySelector("[data-swup-fragment]") != null) return;
                const w = (k = m.__swupFragment) == null ? void 0 : k.url;
                if (!w) return void(O && (i == null || i.warn("no fragment url found:", m)));
                const x = (S = m.__swupFragment) == null ? void 0 : S.selector;
                if (!x) return void(O && (i == null || i.warn("no fragment selector found:", m)));
                const C = o.get(w);
                if (!C) return;
                const L = f.querySelector(x);
                if (!L) return;
                const z = new DOMParser().parseFromString(C.html, "text/html").querySelector(x);
                z && (z.setAttribute("data-swup-fragment-url", w), L.replaceWith(z), g.push(m))
            }), g.length && (o.update(s, {
                fragmentHtml: f.documentElement.outerHTML
            }), g.forEach(m => {
                var k, S;
                const w = ((k = m.__swupFragment) == null ? void 0 : k.url) || "",
                    x = ((S = m.__swupFragment) == null ? void 0 : S.selector) || "";
                O && i?.log(`updated cache with ${F(x)} from ${F(w)}`)
            }))) : O && i?.warn("can't cache foreign fragment elements without swup's cache"))
        })(this)
    }, Ut = function(d) {
        De(d.fragmentVisit, !1)
    };
class Gt extends Pt {
    get parsedRules() {
        return this._parsedRules
    }
    constructor(t) {
        super(), this.name = "SwupFragmentPlugin", this.requires = {
            swup: ">=4.6"
        }, this._rawRules = [], this._parsedRules = [], this.options = void 0, this.defaults = {
            rules: [],
            debug: !1
        }, this.logger = void 0, this.options = oe({}, this.defaults, t)
    }
    mount() {
        const t = this.swup;
        var i;
        this.setRules(this.options.rules), O && this.options.debug && (this.logger = new Ft), this.before("link:self", Yt), this.on("visit:start", Rt), this.before("animation:out:await", Xt), this.before("animation:in:await", Vt), this.before("content:replace", jt), this.on("content:replace", Wt), this.on("visit:end", Ut), O && ((i = this.logger) == null || i.warnIf(!t.options.cache, "fragment caching will only work with swup's cache being active")), at(this)
    }
    unmount() {
        super.unmount(), document.querySelectorAll("[data-swup-fragment]").forEach(t => {
            t.removeAttribute("data-swup-fragment-url"), delete t.__swupFragment
        })
    }
    setRules(t) {
        var i;
        this._rawRules = Je(t), this._parsedRules = t.map(s => this.parseRule(s)), O && ((i = this.logger) == null || i.log("Updated fragment rules", this.getRules()))
    }
    getRules() {
        return Je(this._rawRules)
    }
    prependRule(t) {
        this.setRules([t, ...this.getRules()])
    }
    appendRule(t) {
        this.setRules([...this.getRules(), t])
    }
    parseRule(t) {
        return new Bt(oe({}, t, {
            logger: this.logger,
            swup: this.swup
        }))
    }
    getFragmentVisit(t, i) {
        const s = lt(t, this.parsedRules, i || this.swup.createVisit(t));
        if (!s) return;
        const o = ((v, m, k, S) => {
            let w = m.map(C => {
                const L = document.querySelector(C);
                return L ? Ee(C, k) ? {
                    selector: C,
                    el: L
                } : (O && S?.error(`${F(C)} is outside of swup's default containers`), !1) : (O && S?.log(`${F(C)} missing in current document`), !1)
            }).filter(C => !!C);
            const x = w.every(C => Pe(C.el, v.to));
            return Oe(v.from, v.to) || x && k.options.linkToSelf === "navigate" || (w = w.filter(C => !Pe(C.el, v.to) || (O && S?.log(`ignoring fragment ${F(C.selector)} as it already matches the current URL`), !1))), w.map(C => C.selector)
        })(t, s.containers, this.swup, this.logger);
        if (!o.length) return;
        const {
            name: c,
            scroll: f,
            focus: g
        } = s;
        return {
            containers: o,
            name: c,
            scroll: f,
            focus: g
        }
    }
}

function fe() {
    return fe = Object.assign ? Object.assign.bind() : function(d) {
        for (var t = 1; t < arguments.length; t++) {
            var i = arguments[t];
            for (var s in i) Object.prototype.hasOwnProperty.call(i, s) && (d[s] = i[s])
        }
        return d
    }, fe.apply(this, arguments)
}
const et = d => String(d).split(".").map(t => String(parseInt(t || "0", 10))).concat(["0", "0"]).slice(0, 3).join(".");
class Kt {
    constructor() {
        this.isSwupPlugin = !0, this.swup = void 0, this.version = void 0, this.requires = {}, this.handlersToUnregister = []
    }
    mount() {}
    unmount() {
        this.handlersToUnregister.forEach(t => t()), this.handlersToUnregister = []
    }
    _beforeMount() {
        if (!this.name) throw new Error("You must define a name of plugin when creating a class.")
    }
    _afterUnmount() {}
    _checkRequirements() {
        return typeof this.requires != "object" || Object.entries(this.requires).forEach(([t, i]) => {
            if (!(function(s, o, c) {
                    const f = (function(g, v) {
                        var m;
                        if (g === "swup") return (m = v.version) != null ? m : "";
                        {
                            var k;
                            const S = v.findPlugin(g);
                            return (k = S?.version) != null ? k : ""
                        }
                    })(s, c);
                    return !!f && ((g, v) => v.every(m => {
                        const [, k, S] = m.match(/^([\D]+)?(.*)$/) || [];
                        var w, x;
                        return ((C, L) => {
                            const z = {
                                "": N => N === 0,
                                ">": N => N > 0,
                                ">=": N => N >= 0,
                                "<": N => N < 0,
                                "<=": N => N <= 0
                            };
                            return (z[L] || z[""])(C)
                        })((x = S, w = et(w = g), x = et(x), w.localeCompare(x, void 0, {
                            numeric: !0
                        })), k || ">=")
                    }))(f, o)
                })(t, i = Array.isArray(i) ? i : [i], this.swup)) {
                const s = `${t} ${i.join(", ")}`;
                throw new Error(`Plugin version mismatch: ${this.name} requires ${s}`)
            }
        }), !0
    }
    on(t, i, s = {}) {
        var o;
        i = !(o = i).name.startsWith("bound ") || o.hasOwnProperty("prototype") ? i.bind(this) : i;
        const c = this.swup.hooks.on(t, i, s);
        return this.handlersToUnregister.push(c), c
    }
    once(t, i, s = {}) {
        return this.on(t, i, fe({}, s, {
            once: !0
        }))
    }
    before(t, i, s = {}) {
        return this.on(t, i, fe({}, s, {
            before: !0
        }))
    }
    replace(t, i, s = {}) {
        return this.on(t, i, fe({}, s, {
            replace: !0
        }))
    }
    off(t, i) {
        return this.swup.hooks.off(t, i)
    }
}
class Zt extends Kt {
    constructor(...t) {
        super(...t), this.name = "SwupGtmPlugin"
    }
    mount() {
        this.on("page:view", this.trackPageview)
    }
    trackPageview() {
        if (typeof window.dataLayer != "object") return void console.warn("GTM is not loaded on the page");
        const t = window.location.pathname + window.location.search,
            i = document.title;
        window.dataLayer.push({
            event: "VirtualPageview",
            virtualPageURL: t,
            virtualPageTitle: i
        }), this.swup.log(`GTM page view: ${t}`)
    }
}
P.registerPlugin(j);
class Qt {
    constructor() {
        this.swup = null, this.isInitialized = !1, this.pageTransitionDuration = .6, this.skipAnimation = !1, this.transitionStyle = window.themeSettings?.pageTransitionStyle || "slide"
    }
    init() {
        if (this.isInitialized) return this.swup;
        if (window.Shopify && window.Shopify.designMode) return null;
        window.addEventListener("error", i => {
            if (i.message && i.message.includes("Cannot assign to read only property 'protect'")) return i.preventDefault(), !0
        });
        const t = [{
            from: "(.*)",
            to: "(.*)",
            out: async i => {
                await this.animateOut(), i()
            },
            in: async i => {
                await this.animateIn(), i()
            }
        }];
        return console.log("[SwupManager] Initializing Swup with FragmentPlugin"), this.swup = new $t({
            containers: ["#swup-container"],
            cache: !0,
            animateHistoryBrowsing: !0,
            linkSelector: 'a[href^="' + window.location.origin + '"]:not([data-no-swup]):not([href*="#"]), a[href^="/"]:not([data-no-swup]):not([href^="//"]):not([href^="#"]):not([href*="#"])',
            plugins: [new Gt({
                rules: [{
                    from: "/search(.*)",
                    to: "/search(.*)",
                    containers: ["#search-results-fragment", "#search-filters-fragment", "#search-subtitle-fragment"],
                    name: "search-filters"
                }],
                debug: !0
            }), new Mt(t), new Ot({
                persistAssets: !0,
                persistTags: 'link[rel="stylesheet"], style, script[src]'
            }), new Dt({
                preloadVisibleLinks: !0
            }), new zt, new Ht({
                head: !1,
                body: !0
            }), new Zt]
        }), this.setupEventListeners(), this.swup.hooks.replace("animation:out:await", (i, s, o) => {
            if (!i.fragmentVisit) return o(i, s)
        }), this.swup.hooks.replace("animation:in:await", (i, s, o) => {
            if (i.fragmentVisit) {
                this.animateFragmentElements(i.fragmentVisit.containers);
                return
            }
            return o(i, s)
        }), this.isInitialized = !0, this.swup
    }
    setupEventListeners() {
        this.swup.hooks.on("visit:start", t => {
            t.fragmentVisit || (document.documentElement.classList.add("is-changing"), document.documentElement.classList.add("scroll-locked"), U.stop(), t.to.url.includes("/cart") && this.swup.cache.delete(t.to.url))
        }), this.swup.hooks.on("content:replace", t => {
            if (t.fragmentVisit) {
                requestAnimationFrame(() => {
                    j.refresh()
                });
                return
            }
            j.getAll().forEach(s => s.kill()), this.reinitializeComponents();
            const i = document.querySelector("main");
            i && (i.setAttribute("tabindex", "-1"), i.focus({
                preventScroll: !0
            }), this.announcePageChange()), requestAnimationFrame(() => {
                U.resize(), j.refresh()
            })
        }), this.swup.hooks.on("visit:end", () => {
            document.documentElement.classList.remove("is-changing"), document.documentElement.classList.remove("scroll-locked"), U.start(), window.dispatchEvent(new CustomEvent("swup:transitionEnd"))
        }), this.swup.hooks.on("page:view", () => {
            window.dispatchEvent(new CustomEvent("swup:pageview", {
                detail: {
                    url: window.location.href
                }
            }))
        })
    }
    animateFragmentElements(t) {
        t.forEach(i => {
            const s = document.querySelector(i);
            if (!s) return;
            const o = s.querySelectorAll("[data-tween]");
            o.length > 0 ? o.forEach((c, f) => {
                const g = c.dataset.tweenType || "fade-up";
                g === "clip-right" ? P.fromTo(c, {
                    clipPath: "inset(0 100% 0 0)"
                }, {
                    clipPath: "inset(0 0% 0 0)",
                    duration: 1.2,
                    delay: f * .08,
                    ease: "expo.inOut"
                }) : g === "clip-up" ? P.fromTo(c, {
                    clipPath: "inset(100% 0 0 0)"
                }, {
                    clipPath: "inset(0% 0 0 0)",
                    duration: 1,
                    delay: f * .08,
                    ease: "power3.out"
                }) : P.fromTo(c, {
                    opacity: 0,
                    y: 20
                }, {
                    opacity: 1,
                    y: 0,
                    duration: .4,
                    delay: f * .05,
                    ease: "power2.out"
                })
            }) : P.fromTo(s, {
                opacity: 0
            }, {
                opacity: 1,
                duration: .3,
                ease: "power2.out"
            })
        })
    }
    async animateOut() {
        if (this.skipAnimation) return Promise.resolve();
        const t = document.querySelector("#swup-container"),
            i = document.querySelector(".page-transition-overlay"),
            s = P.timeline();
        switch (this.transitionStyle) {
            case "fade":
                s.to(t, {
                    opacity: 0,
                    duration: .4,
                    ease: "power2.inOut"
                });
                break;
            case "slide":
                s.to(t, {
                    y: -40,
                    opacity: 0,
                    duration: .25,
                    ease: "power2.in"
                });
                break;
            default:
                i && (P.set(i, {
                    transformOrigin: "bottom",
                    scaleY: 0
                }), s.to(i, {
                    scaleY: 1,
                    duration: .4,
                    ease: "power3.inOut"
                })), s.to(t, {
                    y: -40,
                    opacity: 0,
                    duration: .25,
                    ease: "power2.in"
                }, .1);
                break
        }
        return s
    }
    async animateIn() {
        U.scrollTo(0, {
            immediate: !0
        });
        const t = document.querySelector("#swup-container"),
            i = document.querySelector(".page-transition-overlay");
        if (this.skipAnimation) return this.skipAnimation = !1, P.set(t, {
            opacity: 1,
            y: 0,
            x: 0
        }), i && P.set(i, {
            scaleY: 0,
            scaleX: 0
        }), Promise.resolve();
        const s = P.timeline();
        switch (this.transitionStyle) {
            case "fade":
                P.set(t, {
                    opacity: 0,
                    x: 0,
                    y: 0
                }), s.to(t, {
                    opacity: 1,
                    duration: .4,
                    ease: "power2.inOut"
                }), s.add(() => {
                    this.animateRevealElements()
                }, .1);
                break;
            case "slide":
                P.set(t, {
                    opacity: 0,
                    y: 40,
                    x: 0
                }), s.to(t, {
                    y: 0,
                    opacity: 1,
                    duration: .3,
                    ease: "power2.out"
                }), s.add(() => {
                    this.animateRevealElements()
                }, .1);
                break;
            default:
                P.set(t, {
                    opacity: 0,
                    x: 0,
                    y: 40
                }), i && (P.set(i, {
                    transformOrigin: "top",
                    scaleY: 1
                }), s.to(i, {
                    scaleY: 0,
                    duration: .5,
                    ease: "power3.inOut"
                })), s.to(t, {
                    y: 0,
                    opacity: 1,
                    duration: .3,
                    ease: "power2.out"
                }, .2), s.add(() => {
                    this.animateRevealElements()
                }, .3);
                break
        }
        return s
    }
    animateRevealElements() {
        document.querySelectorAll("[data-reveal]").forEach((i, s) => {
            const o = i.dataset.revealDelay || s * .1;
            i.dataset.reveal, P.to(i, {
                opacity: 1,
                x: 0,
                y: 0,
                scale: 1,
                clipPath: "inset(0 0% 0 0)",
                duration: .8,
                delay: o,
                ease: "power2.out"
            })
        })
    }
    announcePageChange() {
        let t = document.getElementById("swup-announce");
        t || (t = document.createElement("div"), t.id = "swup-announce", t.setAttribute("role", "status"), t.setAttribute("aria-live", "polite"), t.setAttribute("aria-atomic", "true"), t.className = "sr-only", document.body.appendChild(t));
        const i = document.title || "Page loaded";
        t.textContent = "", setTimeout(() => {
            t.textContent = i
        }, 100)
    }
    reinitializeComponents() {
        window.dispatchEvent(new CustomEvent("swup:contentReplaced")), window.Shopify && window.Shopify.PaymentButton && window.Shopify.PaymentButton.init(), document.querySelectorAll("details-disclosure, details-modal").forEach(t => {
            t.connectedCallback && t.connectedCallback()
        })
    }
    navigateTo(t, i = !1) {
        this.swup ? (this.skipAnimation = i, this.swup.navigate(t)) : window.location.href = t
    }
    updateUrl(t, i = !1) {
        i ? window.history.replaceState({
            swupPreview: !0
        }, "", t) : window.history.pushState({
            swupPreview: !0
        }, "", t)
    }
    goBack() {
        window.history.back()
    }
    clearCache(t) {
        if (!this.swup || !this.swup.cache) return;
        const i = Array.isArray(t) ? t : [t];
        this.swup.cache.all.forEach((s, o) => {
            i.some(c => o.includes(c)) && this.swup.cache.delete(o)
        })
    }
    clearAllCache() {
        this.swup && this.swup.cache && this.swup.cache.clear()
    }
    destroy() {
        this.swup && (this.swup.destroy(), this.swup = null, this.isInitialized = !1)
    }
}
const _e = new Qt;
P.registerPlugin(j, he);
class Jt {
    constructor() {
        this.scrollTriggers = [], this.splitInstances = [], this.initialized = !1
    }
    getScrollStart(t = "top 80%") {
        if (typeof window.getScrollStart == "function") return window.getScrollStart(t);
        const i = window.themeSettings?.animationTriggerOffset || "md",
            s = {
                none: t,
                sm: "top 90%",
                md: "top 80%",
                lg: "top 70%"
            };
        return s[i] || s.md
    }
    shouldAnimate() {
        if (typeof window.shouldAnimate == "function") return window.shouldAnimate();
        const t = window.matchMedia("(prefers-reduced-motion: reduce)").matches,
            i = window.themeSettings?.enableAnimations !== !1;
        return !t && i
    }
    getAnimationConfig(t) {
        const i = {
            fade: {
                initial: {
                    opacity: 0
                },
                animate: {
                    opacity: 1
                },
                duration: .6,
                ease: "power2.out"
            },
            "fade-up": {
                initial: {
                    opacity: 0,
                    y: 30
                },
                animate: {
                    opacity: 1,
                    y: 0
                },
                duration: .6,
                ease: "power2.out"
            },
            "fade-down": {
                initial: {
                    opacity: 0,
                    y: -30
                },
                animate: {
                    opacity: 1,
                    y: 0
                },
                duration: .6,
                ease: "power2.out"
            },
            "fade-left": {
                initial: {
                    opacity: 0,
                    x: 30
                },
                animate: {
                    opacity: 1,
                    x: 0
                },
                duration: .6,
                ease: "power2.out"
            },
            "fade-right": {
                initial: {
                    opacity: 0,
                    x: -30
                },
                animate: {
                    opacity: 1,
                    x: 0
                },
                duration: .6,
                ease: "power2.out"
            },
            "split-text": {
                duration: 1.2,
                ease: "power4.out",
                stagger: .05
            },
            "clip-right": {
                initial: {
                    clipPath: "inset(0 100% 0 0)"
                },
                animate: {
                    clipPath: "inset(0 0% 0 0)"
                },
                duration: 1.6,
                ease: "expo.inOut"
            },
            "clip-up": {
                initial: {
                    clipPath: "inset(100% 0 0 0)"
                },
                animate: {
                    clipPath: "inset(0% 0 0 0)"
                },
                duration: 1.2,
                ease: "power3.out"
            },
            "clip-down": {
                initial: {
                    clipPath: "inset(0 0 100% 0)"
                },
                animate: {
                    clipPath: "inset(0 0 0% 0)"
                },
                duration: 1.2,
                ease: "power3.out"
            },
            scale: {
                initial: {
                    opacity: 0,
                    scale: .95
                },
                animate: {
                    opacity: 1,
                    scale: 1
                },
                duration: .8,
                ease: "power2.out"
            },
            "scale-up": {
                initial: {
                    opacity: 0,
                    scale: .8
                },
                animate: {
                    opacity: 1,
                    scale: 1
                },
                duration: .8,
                ease: "back.out(1.7)"
            },
            "scale-x": {
                initial: {
                    scaleX: 0,
                    transformOrigin: "left center"
                },
                animate: {
                    scaleX: 1
                },
                duration: .8,
                ease: "power3.out"
            },
            "text-reveal": {
                initial: {
                    yPercent: 120
                },
                animate: {
                    yPercent: 0
                },
                duration: .8,
                ease: "power4.out"
            }
        };
        return i[t] || i["fade-up"]
    }
    initSplitText(t, i, s) {
        const o = parseFloat(t.dataset.tweenDuration) || 1.2,
            c = parseFloat(t.dataset.tweenStagger) || .05,
            f = t.dataset.tweenEase || "power4.out",
            g = new he(t, {
                type: "lines",
                linesClass: "tween-split-line"
            });
        return g.lines.forEach(v => {
            const m = document.createElement("div");
            m.style.overflow = "hidden", m.style.display = "block", m.style.paddingBottom = "0.25em", m.style.marginBottom = "-0.25em", v.parentNode.insertBefore(m, v), m.appendChild(v)
        }), P.set(g.lines, {
            yPercent: 120
        }), i.add(() => {
            t.style.opacity = "1"
        }, s), i.to(g.lines, {
            yPercent: 0,
            duration: o,
            ease: f,
            stagger: c
        }, s), this.splitInstances.push(g), g
    }
    initTweenElement(t, i, s) {
        const o = t.dataset.tweenType || "fade-up",
            c = this.getAnimationConfig(o),
            f = parseFloat(t.dataset.tweenDuration) || c.duration,
            g = t.dataset.tweenEase || c.ease;
        o === "split-text" ? this.initSplitText(t, i, s) : (P.set(t, c.initial), i.to(t, {
            ...c.animate,
            duration: f,
            ease: g
        }, s))
    }
    initTweenGroup(t) {
        t.dataset.tweenGroup;
        const i = t.querySelectorAll("[data-tween]");
        if (i.length === 0) return;
        const s = t.dataset.tweenStart || this.getScrollStart(),
            o = parseFloat(t.dataset.tweenStagger) || .08,
            c = t.getBoundingClientRect(),
            f = c.top < window.innerHeight && c.bottom > 0;
        i.forEach(k => {
            const S = k.dataset.tweenType || "fade-up";
            if (S !== "split-text") {
                const w = this.getAnimationConfig(S);
                P.set(k, w.initial)
            }
        });
        const g = f ? {
                delay: .05
            } : {
                scrollTrigger: {
                    trigger: t,
                    start: s,
                    once: !0
                }
            },
            v = P.timeline(g);
        let m = 0;
        i.forEach((k, S) => {
            const w = k.dataset.tweenType || "fade-up",
                x = parseFloat(k.dataset.tweenDelay) || 0;
            this.getAnimationConfig(w);
            const C = S === 0 ? x : m + x;
            this.initTweenElement(k, v, C), m = C + (w === "split-text" ? .5 : o)
        }), v.scrollTrigger && this.scrollTriggers.push(v.scrollTrigger)
    }
    initStandaloneTweens() {
        const t = document.querySelectorAll("[data-tween]:not([data-tween-initialized])"),
            i = this.getScrollStart();
        t.forEach(s => {
            if (s.closest("[data-tween-group]") || !s.isConnected) return;
            const o = window.getComputedStyle(s);
            if (o.display === "none" || o.visibility === "hidden") return;
            const c = s.dataset.tweenType || "fade-up",
                f = parseFloat(s.dataset.tweenDelay) || 0,
                g = this.getAnimationConfig(c),
                v = parseFloat(s.dataset.tweenDuration) || g.duration,
                m = s.dataset.tweenEase || g.ease,
                k = s.dataset.tweenStart || i;
            if (s.dataset.tweenInitialized = "true", c === "split-text") {
                const S = P.timeline({
                    scrollTrigger: {
                        trigger: s,
                        start: k,
                        once: !0
                    }
                });
                this.initSplitText(s, S, f), S.scrollTrigger && this.scrollTriggers.push(S.scrollTrigger)
            } else {
                P.set(s, g.initial);
                const S = s.getBoundingClientRect();
                if (S.top < window.innerHeight && S.bottom > 0) P.to(s, {
                    ...g.animate,
                    duration: v,
                    ease: m,
                    delay: f
                });
                else try {
                    const x = j.create({
                        trigger: s,
                        start: k,
                        once: !0,
                        onEnter: () => {
                            P.to(s, {
                                ...g.animate,
                                duration: v,
                                ease: m,
                                delay: f
                            })
                        }
                    });
                    x && this.scrollTriggers.push(x)
                } catch {
                    P.to(s, {
                        ...g.animate,
                        duration: v,
                        ease: m,
                        delay: f
                    })
                }
            }
        })
    }
    init() {
        if (!this.shouldAnimate()) {
            this.showAllElements();
            return
        }
        document.querySelectorAll("[data-tween-group]:not([data-tween-group-initialized])").forEach(i => {
            i.dataset.tweenGroupInitialized = "true", this.initTweenGroup(i)
        }), this.initStandaloneTweens(), this.initPolicyPages(), this.initialized = !0
    }
    initPolicyPages() {
        const t = document.querySelector(".shopify-policy__container");
        if (!t) return;
        const i = t.querySelector(".shopify-policy__title"),
            s = t.querySelector(".shopify-policy__body");
        if (!i && !s) return;
        const o = P.timeline({
            delay: .1
        });
        if (i) {
            const c = new he(i, {
                type: "lines",
                linesClass: "tween-split-line"
            });
            c.lines.forEach(f => {
                const g = document.createElement("div");
                g.style.overflow = "hidden", g.style.display = "block", g.style.paddingBottom = "0.25em", g.style.marginBottom = "-0.25em", f.parentNode.insertBefore(g, f), g.appendChild(f)
            }), P.set(c.lines, {
                yPercent: 120
            }), o.add(() => {
                i.style.opacity = "1", i.style.transform = "none"
            }, 0), o.to(c.lines, {
                yPercent: 0,
                duration: 1.2,
                ease: "power4.out",
                stagger: .05
            }, 0), this.splitInstances.push(c)
        }
        s && (P.set(s, {
            opacity: 0,
            y: 30
        }), o.to(s, {
            opacity: 1,
            y: 0,
            duration: .8,
            ease: "power3.out"
        }, i ? .3 : 0))
    }
    showAllElements() {
        document.querySelectorAll("[data-tween]").forEach(i => {
            i.style.opacity = "1", i.style.transform = "none", i.style.clipPath = "none"
        })
    }
    refresh() {
        j.refresh()
    }
    destroy() {
        this.scrollTriggers.forEach(t => {
            t && t.kill && t.kill()
        }), this.scrollTriggers = [], this.splitInstances.forEach(t => {
            t && t.revert && t.revert()
        }), this.splitInstances = [], document.querySelectorAll("[data-tween-initialized]").forEach(t => {
            delete t.dataset.tweenInitialized
        }), document.querySelectorAll("[data-tween-group-initialized]").forEach(t => {
            delete t.dataset.tweenGroupInitialized
        }), this.initialized = !1
    }
    reinit() {
        this.destroy(), this.init()
    }
}
const ue = new Jt,
    Ce = {
        normal: 300
    },
    ze = {
        search: 500,
        cartNote: 500
    },
    dt = {
        announcement: 1e3,
        cartFetch: 8e3
    };
class ei {
    constructor() {
        this.container = null, this.queue = [], this.current = null
    }
    ensureContainer() {
        this.container || (this.container = document.createElement("div"), this.container.className = "toast-container", this.container.setAttribute("role", "status"), this.container.setAttribute("aria-live", "polite"), document.body.appendChild(this.container))
    }
    show(t, i = {}) {
        const {
            type: s = "info",
            duration: o = 4e3
        } = i;
        this.ensureContainer();
        const c = document.createElement("div");
        return c.className = `toast toast--${s}`, c.innerHTML = `
      <span class="toast__icon">
        <i class="ph ${this.getIcon(s)}"></i>
      </span>
      <span class="toast__message">${t}</span>
      <button class="toast__close" aria-label="Dismiss">
        <i class="ph ph-x"></i>
      </button>
    `, c.querySelector(".toast__close").addEventListener("click", () => this.dismiss(c), {
            once: !0
        }), this.container.appendChild(c), requestAnimationFrame(() => {
            c.classList.add("toast--visible")
        }), o > 0 && setTimeout(() => this.dismiss(c), o), c
    }
    getIcon(t) {
        const i = {
            success: "ph-check-circle",
            error: "ph-warning-circle",
            info: "ph-info"
        };
        return i[t] || i.info
    }
    dismiss(t) {
        !t || !t.parentNode || (t.classList.remove("toast--visible"), t.classList.add("toast--leaving"), setTimeout(() => {
            t.remove()
        }, Ce.normal))
    }
    success(t, i = 4e3) {
        return this.show(t, {
            type: "success",
            duration: i
        })
    }
    error(t, i = 5e3) {
        return this.show(t, {
            type: "error",
            duration: i
        })
    }
    info(t, i = 4e3) {
        return this.show(t, {
            type: "info",
            duration: i
        })
    }
}
const re = new ei;
class ti {
    constructor() {
        this.cart = null, this.listeners = new Set, this.isUpdating = !1, this.requestTimeout = dt.cartFetch
    }
    async fetchWithTimeout(t, i = {}) {
        const s = new AbortController,
            o = setTimeout(() => s.abort(), this.requestTimeout);
        try {
            const c = await fetch(t, {
                ...i,
                signal: s.signal
            });
            return clearTimeout(o), c
        } catch (c) {
            throw clearTimeout(o), c
        }
    }
    async handleErrorResponse(t, i) {
        if (t.status === 429) re.error("Too many requests. Please wait a moment and try again.");
        else if (t.status >= 500) re.error("Server error. Please try again later.");
        else {
            const s = await t.json().catch(() => ({}));
            re.error(s.description || i)
        }
    }
    async init() {
        await this.fetch()
    }
    async fetch() {
        try {
            const t = await this.fetchWithTimeout("/cart.js");
            return t.ok ? (this.cart = await t.json(), this.notify(), this.cart) : null
        } catch {
            return null
        }
    }
    get() {
        return this.cart
    }
    getItemCount() {
        return this.cart?.item_count || 0
    }
    getTotalPrice() {
        return this.cart?.total_price || 0
    }
    async updateLine(t, i) {
        this.isUpdating = !0, this.notify();
        const s = window.cartStrings?.error || "Could not update cart";
        try {
            const o = await this.fetchWithTimeout("/cart/change.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    line: t,
                    quantity: i
                })
            });
            o.ok ? (this.cart = await o.json(), document.dispatchEvent(new CustomEvent("cart:updated", {
                detail: {
                    cart: this.cart
                }
            }))) : await this.handleErrorResponse(o, s)
        } catch (o) {
            o.name === "AbortError" ? re.error("Request timed out. Please check your connection.") : re.error(s + ". Please try again.")
        } finally {
            this.isUpdating = !1, this.notify()
        }
        return this.cart
    }
    async addItem(t, i = 1, s = {}) {
        this.isUpdating = !0, this.notify();
        const o = window.cartStrings?.error || "Could not add to cart";
        try {
            const c = await this.fetchWithTimeout("/cart/add.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    id: t,
                    quantity: i,
                    properties: s
                })
            });
            c.ok ? (await this.fetch(), document.dispatchEvent(new CustomEvent("cart:updated", {
                detail: {
                    cart: this.cart
                }
            }))) : await this.handleErrorResponse(c, o)
        } catch (c) {
            c.name === "AbortError" ? re.error("Request timed out. Please check your connection.") : re.error(o + ". Please try again.")
        } finally {
            this.isUpdating = !1, this.notify()
        }
        return this.cart
    }
    async updateNote(t) {
        try {
            await fetch("/cart/update.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    note: t
                })
            }), this.cart && (this.cart.note = t)
        } catch {}
    }
    subscribe(t) {
        return this.listeners.add(t), () => this.listeners.delete(t)
    }
    notify() {
        this.listeners.forEach(t => {
            try {
                t(this.cart, this.isUpdating)
            } catch {}
        })
    }
    formatMoney(t) {
        typeof t == "string" && (t = t.replace(/[^\d.-]/g, ""), t.includes(".") ? t = Math.round(parseFloat(t) * 100) : t = parseInt(t, 10)), t = t || 0;
        const i = window.themeSettings?.moneyFormat || "${{amount}}",
            s = t / 100,
            o = Math.floor(s),
            c = s.toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }),
            f = s.toLocaleString("de-DE", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }),
            g = o.toLocaleString("de-DE"),
            v = s.toLocaleString("de-CH", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }),
            m = s.toLocaleString("fr-FR", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }),
            k = o.toLocaleString("fr-FR");
        return i.replace("{{amount_with_comma_separator}}", f).replace("{{amount_no_decimals_with_comma_separator}}", g).replace("{{amount_with_apostrophe_separator}}", v).replace("{{amount_no_decimals_with_space_separator}}", k).replace("{{amount_with_space_separator}}", m).replace("{{amount_no_decimals}}", o.toLocaleString("en-US")).replace("{{amount}}", c)
    }
    getSizedImageUrl(t, i) {
        if (!t) return "";
        const s = t.match(/^(.+?)(\.(jpg|jpeg|png|gif|webp))(\?.*)?$/i);
        return s ? `${s[1]}_${i}${s[2]}${s[4]||""}` : t
    }
}
const M = new ti;

function ii(d) {
    const t = ['button:not([disabled]):not([tabindex="-1"])', '[href]:not([tabindex="-1"])', 'input:not([disabled]):not([tabindex="-1"])', 'select:not([disabled]):not([tabindex="-1"])', 'textarea:not([disabled]):not([tabindex="-1"])', '[tabindex]:not([tabindex="-1"])'].join(", ");
    let i = [],
        s = null,
        o = null;

    function c() {
        i = [...d.querySelectorAll(t)], s = i[0], o = i[i.length - 1]
    }

    function f(g) {
        g.key === "Tab" && (c(), i.length && (g.shiftKey ? document.activeElement === s && (g.preventDefault(), o.focus()) : document.activeElement === o && (g.preventDefault(), s.focus())))
    }
    return d.addEventListener("keydown", f), c(), s && requestAnimationFrame(() => s.focus()), {
        update: c,
        destroy() {
            d.removeEventListener("keydown", f)
        }
    }
}
class ni {
    constructor() {
        this.drawer = null, this.backdrop = null, this.panel = null, this.isOpen = !1, this.isAnimating = !1, this.noteTimeout = null, this.boundHandlers = {}, this.unsubscribe = null, this.focusTrap = null
    }
    init() {
        this.drawer = document.getElementById("cart-drawer"), this.drawer && (this.backdrop = this.drawer.querySelector(".drawer-backdrop"), this.panel = this.drawer.querySelector("[data-cart-drawer-panel]"), this.unsubscribe = M.subscribe((t, i) => {
            this.onCartStateChange(t, i)
        }), this.bindEvents(), this.bindGlobalEvents())
    }
    onCartStateChange(t, i) {
        this.drawer && (i ? (this.drawer.classList.add("is-loading"), this.drawer.setAttribute("aria-busy", "true")) : (this.drawer.classList.remove("is-loading"), this.drawer.setAttribute("aria-busy", "false")), this.isOpen && t && this.render())
    }
    announce(t) {
        const i = this.drawer?.querySelector("[data-cart-status]");
        i && (i.textContent = t, setTimeout(() => {
            i.textContent = ""
        }, dt.announcement))
    }
    bindEvents() {
        this.boundHandlers.handleClose = this.handleClose.bind(this), this.drawer.querySelectorAll("[data-cart-drawer-close]").forEach(i => {
            i.addEventListener("click", this.boundHandlers.handleClose)
        }), this.boundHandlers.handleClick = this.handleClick.bind(this), this.drawer.addEventListener("click", this.boundHandlers.handleClick), this.boundHandlers.handleChange = this.handleChange.bind(this), this.drawer.addEventListener("change", this.boundHandlers.handleChange), this.boundHandlers.handleNoteInput = this.handleNoteInput.bind(this);
        const t = this.drawer.querySelector("[data-cart-note]");
        t && t.addEventListener("input", this.boundHandlers.handleNoteInput), this.boundHandlers.handleKeydown = this.handleKeydown.bind(this), document.addEventListener("keydown", this.boundHandlers.handleKeydown), this.boundHandlers.handleLinkClick = this.handleLinkClick.bind(this), this.drawer.addEventListener("click", this.boundHandlers.handleLinkClick)
    }
    handleLinkClick(t) {
        const i = t.target.closest("a[href]");
        if (!i || i.hasAttribute("data-cart-drawer-close")) return;
        const s = i.getAttribute("href");
        !s || s.startsWith("#") || s.startsWith("http") || s.startsWith("//") || this.close()
    }
    bindGlobalEvents() {
        this.boundHandlers.open = this.open.bind(this), document.addEventListener("cart:open", this.boundHandlers.open), this.boundHandlers.toggle = this.toggle.bind(this), document.addEventListener("cart:toggle", this.boundHandlers.toggle), this.boundHandlers.closeOnNavigation = () => {
            this.isOpen && this.close()
        }, window.addEventListener("swup:contentReplaced", this.boundHandlers.closeOnNavigation)
    }
    handleClose(t) {
        t.target.closest("a") ? setTimeout(() => this.close(), 100) : this.close()
    }
    async handleClick(t) {
        const i = t.target.closest("[data-quantity-minus]"),
            s = t.target.closest("[data-quantity-plus]"),
            o = t.target.closest("[data-remove-item]");
        if (i || s || o) {
            t.preventDefault();
            const c = parseInt(i?.dataset.line || s?.dataset.line || o?.dataset.line),
                f = this.drawer.querySelector(`[data-quantity-input][data-line="${c}"]`),
                v = this.drawer.querySelector(`[data-line-index="${c}"]`)?.querySelector("a")?.textContent?.trim() || "Item";
            let m = parseInt(f?.value || 0);
            i && m > 0 && m--, s && m++, o && (m = 0), await M.updateLine(c, m), o || m === 0 ? this.announce(`${v} removed from cart`) : this.announce(`${v} quantity updated to ${m}`)
        }
    }
    async handleChange(t) {
        if (t.target.matches("[data-quantity-input]")) {
            const i = parseInt(t.target.dataset.line),
                s = parseInt(t.target.value) || 0;
            await M.updateLine(i, s)
        }
    }
    handleNoteInput(t) {
        clearTimeout(this.noteTimeout), this.noteTimeout = setTimeout(() => {
            M.updateNote(t.target.value)
        }, ze.cartNote)
    }
    handleKeydown(t) {
        t.key === "Escape" && this.isOpen && this.close()
    }
    async open(t) {
        if (this.isAnimating || this.isOpen || !this.drawer) return;
        this.isAnimating = !0;
        const i = t?.detail?.skipFetch || t?.skipFetch || !1;
        this.previouslyFocused = document.activeElement;
        const s = document.querySelectorAll("[data-cart-drawer-toggle]");
        i || (s.forEach(o => o.style.cursor = "wait"), await M.fetch(), s.forEach(o => o.style.cursor = "")), this.render(), this.drawer.classList.add("is-open"), this.drawer.removeAttribute("inert"), this.drawer.removeAttribute("aria-hidden"), this.isOpen = !0, U.stop(), document.dispatchEvent(new CustomEvent("cart:opened")), document.dispatchEvent(new CustomEvent("cart:updated", {
            detail: {
                cart: M.get()
            }
        })), setTimeout(() => {
            this.isAnimating = !1, this.focusTrap = ii(this.panel)
        }, Ce.normal)
    }
    close() {
        this.isAnimating || !this.isOpen || !this.drawer || (this.isAnimating = !0, this.focusTrap && (this.focusTrap.destroy(), this.focusTrap = null), document.dispatchEvent(new CustomEvent("cart:closed")), this.drawer.classList.remove("is-open"), setTimeout(() => {
            this.drawer.setAttribute("inert", ""), this.isOpen = !1, this.isAnimating = !1, U.start(), this.previouslyFocused && this.previouslyFocused.focus && (this.previouslyFocused.focus(), this.previouslyFocused = null)
        }, Ce.normal))
    }
    toggle() {
        this.isOpen ? this.close() : this.open()
    }
    async render() {
        if (this.drawer) try {
            const t = await fetch("/?section_id=cart-drawer");
            if (t.ok) {
                const i = await t.text(),
                    o = new DOMParser().parseFromString(i, "text/html"),
                    c = o.querySelector("[data-cart-drawer-content]"),
                    f = o.querySelector("[data-cart-drawer-footer]"),
                    g = this.drawer.querySelector("[data-cart-drawer-content]"),
                    v = this.drawer.querySelector("[data-cart-drawer-footer]");
                c && g && g.replaceChildren(...c.cloneNode(!0).childNodes), f ? v ? v.outerHTML = f.outerHTML : this.panel.insertAdjacentHTML("beforeend", f.outerHTML) : v && v.remove()
            }
        } catch {
            this.renderFallback()
        }
    }
    renderFallback() {
        const t = M.get();
        if (!t || !this.drawer) return;
        const i = this.drawer.querySelector("[data-cart-drawer-content]"),
            s = this.drawer.querySelector("[data-cart-drawer-footer]");
        t.item_count === 0 ? (i.innerHTML = this.renderEmptyCart(), s && s.remove()) : (i.innerHTML = this.renderCartItems(t), s ? s.outerHTML = this.renderFooter(t) : this.panel.insertAdjacentHTML("beforeend", this.renderFooter(t)))
    }
    renderEmptyCart() {
        const t = window.themeStrings?.cartEmpty || "Your cart is empty",
            i = window.themeStrings?.cartEmptyDescription || "Add some items to get started",
            s = window.themeStrings?.cartStartShopping || "Start shopping",
            o = window.routes?.allProductsCollectionUrl || "/collections/all";
        return `
      <div class="cart-drawer__empty">
        <h3 class="text-xl font-semibold text-[--color-text] font-heading">${t}</h3>
        <p>${i}</p>
        <a href="${o}" class="btn btn--primary btn--full" data-cart-drawer-close>
          <i class="ph ph-storefront"></i>
          <span>${s}</span>
        </a>
      </div>
    `
    }
    renderCartItems(t) {
        return `
      <ul class="cart-drawer__items" role="list">
        ${t.items.map((i,s)=>this.renderCartItem(i,s+1)).join("")}
      </ul>
    `
    }
    renderCartItem(t, i) {
        const s = t.variant_title && t.variant_title !== "Default Title",
            o = t.original_line_price !== t.final_line_price,
            c = t.original_line_price;
        return `
      <li class="cart-drawer__item" data-cart-item data-line-index="${i}">
        <div class="cart-drawer__item-image">
          ${t.image?`
            <a href="${t.url}">
              <img
                src="${M.getSizedImageUrl(t.image,"200x")}"
                alt="${t.title}"
                class="w-full h-full object-cover"
                loading="lazy"
              >
            </a>
          `:""}
        </div>

        <div class="cart-drawer__item-details">
          <a href="${t.url}" class="cart-drawer__item-title">
            ${t.product_title}
          </a>
          ${s?`<p class="cart-drawer__item-variant">${t.variant_title}</p>`:""}

          <div class="cart-drawer__item-price">
            ${o?`<span class="cart-drawer__item-price--compare">${M.formatMoney(c)}</span>`:""}
            <span class="${o?"sale-price":""}">${M.formatMoney(t.final_line_price)}</span>
          </div>

          <div class="cart-drawer__item-actions">
            <div class="cart-drawer__quantity" data-quantity-wrapper style="display: inline-flex; align-items: center; height: 2.375rem; padding: 0; background-color: var(--color-background); border: var(--input-border-width) solid var(--color-border); border-radius: var(--input-radius); box-shadow: var(--input-shadow);">
              <button
                type="button"
                class="cart-drawer__quantity-btn"
                data-quantity-minus
                data-line="${i}"
                aria-label="${window.themeStrings?.decreaseQuantity||"Decrease quantity"}"
              >
                <i class="ph ph-minus"></i>
              </button>
              <div class="cart-drawer__quantity-value">
                <input
                  type="number"
                  class="cart-drawer__quantity-input"
                  value="${t.quantity}"
                  min="0"
                  data-quantity-input
                  data-line="${i}"
                  aria-label="${window.themeStrings?.quantity||"Quantity"}"
                  style="border: none !important; box-shadow: none !important; outline: none !important; background: transparent !important;"
                >
              </div>
              <button
                type="button"
                class="cart-drawer__quantity-btn"
                data-quantity-plus
                data-line="${i}"
                aria-label="${window.themeStrings?.increaseQuantity||"Increase quantity"}"
              >
                <i class="ph ph-plus"></i>
              </button>
            </div>
            <button
              type="button"
              class="cart-drawer__remove"
              data-remove-item
              data-line="${i}"
              aria-label="${(window.themeStrings?.removeItem||"Remove {{ title }}").replace("{{ title }}",t.product_title)}"
            >
              <i class="ph ph-trash"></i>
            </button>
          </div>
        </div>
      </li>
    `
    }
    renderFooter(t) {
        const i = window.themeStrings?.cartAddNote || "Add a note",
            s = window.themeStrings?.cartNotePlaceholder || "Add special instructions...",
            o = window.themeStrings?.cartSubtotal || "Subtotal",
            c = window.themeStrings?.cartTaxesNote || "Taxes and shipping calculated at checkout",
            f = window.themeStrings?.cartViewCart || "View cart",
            g = window.themeStrings?.cartCheckout || "Checkout",
            v = window.routes?.cartUrl || "/cart";
        return `
      <div class="p-6 border-t border-[--color-border] bg-[--color-background]" data-cart-drawer-footer>
        <details class="mb-4 group/note">
          <summary class="flex items-center justify-between w-full py-3 text-xs font-semibold tracking-wide uppercase text-[--color-text-secondary] cursor-pointer transition-colors hover:text-[--color-text]">
            <span>${i}</span>
            <i class="ph ph-caret-down text-base transition-transform group-open/note:rotate-180"></i>
          </summary>
          <div class="pb-4">
            <textarea
              name="note"
              class="w-full min-h-[80px] p-3 text-sm bg-transparent border border-[--color-border] text-[--color-text] resize-y focus:outline-2 focus:outline-[--color-primary] focus:-outline-offset-2"
              placeholder="${s}"
              data-cart-note
            >${t.note||""}</textarea>
          </div>
        </details>

        <div class="flex justify-between items-center text-base font-semibold mb-2">
          <span>${o}</span>
          <span data-cart-subtotal>${M.formatMoney(t.total_price)}</span>
        </div>
        <p class="text-xs text-[--color-text-secondary] m-0 mb-4">${c}</p>

        <div class="flex flex-col gap-3">
          <a href="${v}" class="btn btn--secondary btn--full" data-cart-drawer-close>
            <span>${f}</span>
          </a>
          <form action="${v}" method="post" class="m-0">
            <button type="submit" name="checkout" class="btn btn--primary btn--full">
              <i class="ph ph-lock-simple"></i>
              <span>${g}</span>
            </button>
          </form>
        </div>
      </div>
    `
    }
    async refresh() {
        await M.fetch(), this.render()
    }
    reinit() {
        this.destroy(), this.init()
    }
    destroy() {
        if (!this.drawer) return;
        this.unsubscribe && (this.unsubscribe(), this.unsubscribe = null), this.drawer.querySelectorAll("[data-cart-drawer-close]").forEach(i => {
            i.removeEventListener("click", this.boundHandlers.handleClose)
        }), this.drawer.removeEventListener("click", this.boundHandlers.handleClick), this.drawer.removeEventListener("click", this.boundHandlers.handleLinkClick), this.drawer.removeEventListener("change", this.boundHandlers.handleChange);
        const t = this.drawer.querySelector("[data-cart-note]");
        t && t.removeEventListener("input", this.boundHandlers.handleNoteInput), document.removeEventListener("keydown", this.boundHandlers.handleKeydown), document.removeEventListener("cart:open", this.boundHandlers.open), document.removeEventListener("cart:toggle", this.boundHandlers.toggle), window.removeEventListener("swup:contentReplaced", this.boundHandlers.closeOnNavigation), clearTimeout(this.noteTimeout), this.focusTrap && (this.focusTrap.destroy(), this.focusTrap = null), this.drawer = null, this.backdrop = null, this.panel = null, this.isOpen = !1, this.isAnimating = !1
    }
}
const de = new ni;
class si {
    constructor() {
        this.wrapper = null, this.noteTimeout = null, this.isInitialized = !1, this.isReady = !1, this.unsubscribe = null
    }
    init() {
        this.wrapper = document.querySelector("[data-cart-wrapper]"), this.wrapper && (this.wrapper.dataset.cartPageInitialized || (this.wrapper.dataset.cartPageInitialized = "true", this.unsubscribe = M.subscribe((t, i) => {
            this.onCartStateChange(t, i)
        }), this.bindEvents(), this.initAnimations(), this.isInitialized = !0))
    }
    onCartStateChange(t, i) {
        this.wrapper && (i ? this.wrapper.classList.add("is-updating") : (this.wrapper.classList.remove("is-updating"), t && this.isReady && this.render()))
    }
    bindEvents() {
        this.wrapper.addEventListener("click", async i => {
            const s = i.target.closest("[data-quantity-minus]"),
                o = i.target.closest("[data-quantity-plus]"),
                c = i.target.closest("[data-remove-item]");
            if (s || o || c) {
                i.preventDefault();
                const f = i.target.closest("[data-cart-item]"),
                    g = parseInt(f?.dataset.line),
                    v = f?.querySelector("[data-quantity-input]");
                let m = parseInt(v?.value || 0);
                s && m > 0 && m--, o && m++, c && (m = 0), await M.updateLine(g, m)
            }
        }), this.wrapper.addEventListener("change", async i => {
            if (i.target.matches("[data-quantity-input]")) {
                const s = parseInt(i.target.dataset.line),
                    o = parseInt(i.target.value) || 0;
                await M.updateLine(s, o)
            }
        });
        const t = this.wrapper.querySelector("[data-cart-note]");
        t && t.addEventListener("input", i => {
            clearTimeout(this.noteTimeout), this.noteTimeout = setTimeout(() => {
                M.updateNote(i.target.value)
            }, ze.cartNote)
        })
    }
    initAnimations() {
        this.isReady = !0
    }
    render() {
        const t = M.get();
        if (!t || !this.wrapper) return;
        const i = this.wrapper.querySelector("[data-subtitle-text]");
        if (i) {
            const s = t.item_count === 1 ? "Item" : "Items";
            i.textContent = `${t.item_count} ${s}`
        }
        t.item_count === 0 ? this.renderEmptyState() : this.renderCartContent(t)
    }
    renderEmptyState() {
        const t = this.wrapper.querySelector(".lg\\:grid") || this.wrapper.querySelector("[data-cart-form]")?.parentElement?.parentElement,
            i = window.themeStrings?.cartEmpty || "Your cart is empty",
            s = window.themeStrings?.cartEmptyDescription || "Looks like you haven't added anything yet.",
            o = window.themeStrings?.cartStartShopping || "Start Shopping",
            c = window.themeStrings?.backHome || "Back to Home",
            f = window.routes?.allProductsCollectionUrl || "/collections/all",
            g = window.routes?.rootUrl || "/",
            v = this.wrapper.querySelector('[class*="page-container"]') ? "page-container" : "page-full";
        t && (t.outerHTML = `
        <div class="${v} pb-[--page-vertical-padding]">
          <h2 class="text-2xl md:text-3xl font-semibold text-[--color-text] font-heading">${i}</h2>
          <p class="mt-4 text-[--color-text-secondary] max-w-sm">${s}</p>

          <div class="mt-10 flex flex-col sm:flex-row gap-4 max-w-xs sm:max-w-none">
            <a href="${f}" class="btn btn--primary w-full sm:w-auto">
              <i class="ph ph-storefront"></i>
              <span>${o}</span>
            </a>
            <a href="${g}" class="btn btn--secondary w-full sm:w-auto">
              <i class="ph ph-house"></i>
              <span>${c}</span>
            </a>
          </div>
        </div>
      `)
    }
    renderCartContent(t) {
        const i = this.wrapper.querySelector("[data-cart-form] ul");
        i && (i.innerHTML = t.items.map((s, o) => this.renderCartItem(s, o + 1)).join("")), this.updateSummary(t)
    }
    renderCartItem(t, i) {
        const s = t.variant_title && t.variant_title !== "Default Title",
            o = t.original_line_price !== t.final_line_price,
            c = t.selling_plan_allocation,
            f = window.themeStrings?.cartRemove || "Remove";
        return `
      <li class="py-8 first:pt-0" data-cart-item data-line="${i}">
        <div class="flex gap-6">
          <div class="w-28 h-36 flex-shrink-0 overflow-hidden bg-[--color-background-secondary]">
            ${t.image?`
              <a href="${t.url}">
                <img
                  src="${M.getSizedImageUrl(t.image,"300x")}"
                  alt="${t.title}"
                  class="w-full h-full object-cover"
                  loading="lazy"
                >
              </a>
            `:""}
          </div>

          <div class="flex flex-1 flex-col justify-between">
            <div>
              <div class="flex justify-between">
                <div>
                  <h3 class="text-base font-medium text-[--color-text]">
                    <a href="${t.url}" class="hover:text-[--color-primary] transition-colors">
                      ${t.product_title}
                    </a>
                  </h3>
                  ${s?`<p class="mt-1 text-sm text-[--color-text-secondary]">${t.variant_title}</p>`:""}
                  ${c?`<p class="mt-1 text-xs text-[--color-text-secondary]">${t.selling_plan_allocation.selling_plan.name}</p>`:""}
                </div>
                <div class="text-right">
                  <p class="text-base font-medium text-[--color-text]">${M.formatMoney(t.final_line_price)}</p>
                  ${o?`<p class="text-sm text-[--color-text-secondary] line-through">${M.formatMoney(t.original_line_price)}</p>`:""}
                </div>
              </div>
            </div>

            <div class="flex items-center justify-between mt-4">
              <div class="cart-quantity" data-quantity-wrapper>
                <button type="button" class="cart-quantity-btn" data-quantity-minus aria-label="${window.themeStrings?.decreaseQuantity||"Decrease quantity"}">
                  <i class="ph ph-minus"></i>
                </button>
                <div class="cart-quantity-value">
                  <input
                    type="number"
                    name="updates[]"
                    value="${t.quantity}"
                    min="0"
                    class="cart-quantity-input"
                    data-quantity-input
                    data-line="${i}"
                    aria-label="${window.themeStrings?.quantity||"Quantity"}"
                  >
                </div>
                <button type="button" class="cart-quantity-btn" data-quantity-plus aria-label="${window.themeStrings?.increaseQuantity||"Increase quantity"}">
                  <i class="ph ph-plus"></i>
                </button>
              </div>

              <button
                type="button"
                class="text-xs uppercase tracking-wider font-medium text-[--color-text-secondary] hover:text-[--color-text] transition-colors"
                data-remove-item
                data-line="${i}"
              >
                ${f}
              </button>
            </div>
          </div>
        </div>
      </li>
    `
    }
    updateSummary(t) {
        const i = this.wrapper.querySelector("[data-cart-subtotal]");
        i && (i.textContent = M.formatMoney(t.total_price));
        const s = this.wrapper.querySelector("[data-cart-total]");
        s && (s.textContent = M.formatMoney(t.total_price));
        const o = this.wrapper.querySelector("[data-cart-note]");
        o && t.note !== o.value && (o.value = t.note || "")
    }
    reinit() {
        this.destroy(), this.init()
    }
    destroy() {
        this.unsubscribe && (this.unsubscribe(), this.unsubscribe = null), clearTimeout(this.noteTimeout), this.wrapper = null, this.isInitialized = !1, this.isReady = !1
    }
}
const Ie = new si;

function ri(d) {
    return d && d.__esModule && Object.prototype.hasOwnProperty.call(d, "default") ? d.default : d
}
var Se = {
        exports: {}
    },
    ai = Se.exports,
    tt;

function oi() {
    return tt || (tt = 1, (function(d, t) {
        (function(i, s) {
            d.exports = s()
        })(ai, (function() {
            function i(e, n) {
                if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function")
            }

            function s(e, n) {
                for (var r = 0; r < n.length; r++) {
                    var a = n[r];
                    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, c(a.key), a)
                }
            }

            function o(e, n, r) {
                return n && s(e.prototype, n), Object.defineProperty(e, "prototype", {
                    writable: !1
                }), e
            }

            function c(e) {
                var n = (function(r, a) {
                    if (typeof r != "object" || !r) return r;
                    var l = r[Symbol.toPrimitive];
                    if (l !== void 0) {
                        var h = l.call(r, a);
                        if (typeof h != "object") return h;
                        throw new TypeError("@@toPrimitive must return a primitive value.")
                    }
                    return String(r)
                })(e, "string");
                return typeof n == "symbol" ? n : n + ""
            }

            function f(e) {
                return (f = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
                    return typeof n
                } : function(n) {
                    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n
                })(e)
            }
            var g = Date.now();

            function v() {
                var e = {},
                    n = !0,
                    r = 0,
                    a = arguments.length;
                Object.prototype.toString.call(arguments[0]) === "[object Boolean]" && (n = arguments[0], r++);
                for (var l = function(u) {
                        for (var p in u) Object.prototype.hasOwnProperty.call(u, p) && (n && Object.prototype.toString.call(u[p]) === "[object Object]" ? e[p] = v(!0, e[p], u[p]) : e[p] = u[p])
                    }; r < a; r++) {
                    var h = arguments[r];
                    l(h)
                }
                return e
            }

            function m(e, n) {
                if ((Z(e) || e === window || e === document) && (e = [e]), Be(e) || le(e) || (e = [e]), Ye(e) != 0) {
                    if (Be(e) && !le(e))
                        for (var r = e.length, a = 0; a < r && n.call(e[a], e[a], a, e) !== !1; a++);
                    else if (le(e)) {
                        for (var l in e)
                            if (H(e, l) && n.call(e[l], e[l], l, e) === !1) break
                    }
                }
            }

            function k(e) {
                var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null,
                    r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null,
                    a = e[g] = e[g] || [],
                    l = {
                        all: a,
                        evt: null,
                        found: null
                    };
                return n && r && Ye(a) > 0 && m(a, (function(h, u) {
                    if (h.eventName == n && h.fn.toString() == r.toString()) return l.found = !0, l.evt = u, !1
                })), l
            }

            function S(e) {
                var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {},
                    r = n.onElement,
                    a = n.withCallback,
                    l = n.avoidDuplicate,
                    h = l === void 0 || l,
                    u = n.once,
                    p = u !== void 0 && u,
                    b = n.useCapture,
                    y = b !== void 0 && b,
                    E = arguments.length > 2 ? arguments[2] : void 0,
                    T = r || [];

                function A(q) {
                    I(a) && a.call(E, q, this), p && A.destroy()
                }
                return pe(T) && (T = document.querySelectorAll(T)), A.destroy = function() {
                    m(T, (function(q) {
                        var _ = k(q, e, A);
                        _.found && _.all.splice(_.evt, 1), q.removeEventListener && q.removeEventListener(e, A, y)
                    }))
                }, m(T, (function(q) {
                    var _ = k(q, e, A);
                    (q.addEventListener && h && !_.found || !h) && (q.addEventListener(e, A, y), _.all.push({
                        eventName: e,
                        fn: A
                    }))
                })), A
            }

            function w(e, n) {
                m(n.split(" "), (function(r) {
                    return e.classList.add(r)
                }))
            }

            function x(e, n) {
                m(n.split(" "), (function(r) {
                    return e.classList.remove(r)
                }))
            }

            function C(e, n) {
                return e.classList.contains(n)
            }

            function L(e, n) {
                for (; e !== document.body;) {
                    if (!(e = e.parentElement)) return !1;
                    if (typeof e.matches == "function" ? e.matches(n) : e.msMatchesSelector(n)) return e
                }
            }

            function z(e) {
                var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "",
                    r = arguments.length > 2 && arguments[2] !== void 0 && arguments[2];
                if (!e || n === "") return !1;
                if (n === "none") return I(r) && r(), !1;
                var a = ht(),
                    l = n.split(" ");
                m(l, (function(h) {
                    w(e, "g" + h)
                })), S(a, {
                    onElement: e,
                    avoidDuplicate: !1,
                    once: !0,
                    withCallback: function(h, u) {
                        m(l, (function(p) {
                            x(u, "g" + p)
                        })), I(r) && r()
                    }
                })
            }

            function N(e) {
                var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
                if (n === "") return e.style.webkitTransform = "", e.style.MozTransform = "", e.style.msTransform = "", e.style.OTransform = "", e.style.transform = "", !1;
                e.style.webkitTransform = n, e.style.MozTransform = n, e.style.msTransform = n, e.style.OTransform = n, e.style.transform = n
            }

            function ie(e) {
                e.style.display = "block"
            }

            function ne(e) {
                e.style.display = "none"
            }

            function se(e) {
                var n = document.createDocumentFragment(),
                    r = document.createElement("div");
                for (r.innerHTML = e; r.firstChild;) n.appendChild(r.firstChild);
                return n
            }

            function He() {
                return {
                    width: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
                    height: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
                }
            }

            function ht() {
                var e, n = document.createElement("fakeelement"),
                    r = {
                        animation: "animationend",
                        OAnimation: "oAnimationEnd",
                        MozAnimation: "animationend",
                        WebkitAnimation: "webkitAnimationEnd"
                    };
                for (e in r)
                    if (n.style[e] !== void 0) return r[e]
            }

            function ke(e, n, r, a) {
                if (e()) n();
                else {
                    var l;
                    r || (r = 100);
                    var h = setInterval((function() {
                        e() && (clearInterval(h), l && clearTimeout(l), n())
                    }), r)
                }
            }

            function Ne(e, n, r) {
                if (X(e)) console.error("Inject assets error");
                else if (I(n) && (r = n, n = !1), pe(n) && n in window) I(r) && r();
                else {
                    var a;
                    if (e.indexOf(".css") !== -1) {
                        if ((a = document.querySelectorAll('link[href="' + e + '"]')) && a.length > 0) return void(I(r) && r());
                        var l = document.getElementsByTagName("head")[0],
                            h = l.querySelectorAll('link[rel="stylesheet"]'),
                            u = document.createElement("link");
                        return u.rel = "stylesheet", u.type = "text/css", u.href = e, u.media = "all", h ? l.insertBefore(u, h[0]) : l.appendChild(u), void(I(r) && r())
                    }
                    if ((a = document.querySelectorAll('script[src="' + e + '"]')) && a.length > 0) {
                        if (I(r)) {
                            if (pe(n)) return ke((function() {
                                return window[n] !== void 0
                            }), (function() {
                                r()
                            })), !1;
                            r()
                        }
                    } else {
                        var p = document.createElement("script");
                        p.type = "text/javascript", p.src = e, p.onload = function() {
                            if (I(r)) {
                                if (pe(n)) return ke((function() {
                                    return window[n] !== void 0
                                }), (function() {
                                    r()
                                })), !1;
                                r()
                            }
                        }, document.body.appendChild(p)
                    }
                }
            }

            function Ae() {
                return "navigator" in window && window.navigator.userAgent.match(/(iPad)|(iPhone)|(iPod)|(Android)|(PlayBook)|(BB10)|(BlackBerry)|(Opera Mini)|(IEMobile)|(webOS)|(MeeGo)/i)
            }

            function I(e) {
                return typeof e == "function"
            }

            function pe(e) {
                return typeof e == "string"
            }

            function Z(e) {
                return !(!e || !e.nodeType || e.nodeType != 1)
            }

            function Fe(e) {
                return Array.isArray(e)
            }

            function Be(e) {
                return e && e.length && isFinite(e.length)
            }

            function le(e) {
                return f(e) === "object" && e != null && !I(e) && !Fe(e)
            }

            function X(e) {
                return e == null
            }

            function H(e, n) {
                return e !== null && hasOwnProperty.call(e, n)
            }

            function Ye(e) {
                if (le(e)) {
                    if (e.keys) return e.keys().length;
                    var n = 0;
                    for (var r in e) H(e, r) && n++;
                    return n
                }
                return e.length
            }

            function me(e) {
                return !isNaN(parseFloat(e)) && isFinite(e)
            }

            function Re() {
                var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : -1,
                    n = document.querySelectorAll(".gbtn[data-taborder]:not(.disabled)");
                if (!n.length) return !1;
                if (n.length == 1) return n[0];
                typeof e == "string" && (e = parseInt(e));
                var r = [];
                m(n, (function(p) {
                    r.push(p.getAttribute("data-taborder"))
                }));
                var a = Math.max.apply(Math, r.map((function(p) {
                        return parseInt(p)
                    }))),
                    l = e < 0 ? 1 : e + 1;
                l > a && (l = "1");
                var h = r.filter((function(p) {
                        return p >= parseInt(l)
                    })),
                    u = h.sort()[0];
                return document.querySelector('.gbtn[data-taborder="'.concat(u, '"]'))
            }

            function pt(e) {
                if (e.events.hasOwnProperty("keyboard")) return !1;
                e.events.keyboard = S("keydown", {
                    onElement: window,
                    withCallback: function(n, r) {
                        var a = (n = n || window.event).keyCode;
                        if (a == 9) {
                            var l = document.querySelector(".gbtn.focused");
                            if (!l) {
                                var h = !(!document.activeElement || !document.activeElement.nodeName) && document.activeElement.nodeName.toLocaleLowerCase();
                                if (h == "input" || h == "textarea" || h == "button") return
                            }
                            n.preventDefault();
                            var u = document.querySelectorAll(".gbtn[data-taborder]");
                            if (!u || u.length <= 0) return;
                            if (!l) {
                                var p = Re();
                                return void(p && (p.focus(), w(p, "focused")))
                            }
                            var b = Re(l.getAttribute("data-taborder"));
                            x(l, "focused"), b && (b.focus(), w(b, "focused"))
                        }
                        a == 39 && e.nextSlide(), a == 37 && e.prevSlide(), a == 27 && e.close()
                    }
                })
            }
            var gt = o((function e(n, r) {
                    var a = this,
                        l = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
                    if (i(this, e), this.img = n, this.slide = r, this.onclose = l, this.img.setZoomEvents) return !1;
                    this.active = !1, this.zoomedIn = !1, this.dragging = !1, this.currentX = null, this.currentY = null, this.initialX = null, this.initialY = null, this.xOffset = 0, this.yOffset = 0, this.img.addEventListener("mousedown", (function(h) {
                        return a.dragStart(h)
                    }), !1), this.img.addEventListener("mouseup", (function(h) {
                        return a.dragEnd(h)
                    }), !1), this.img.addEventListener("mousemove", (function(h) {
                        return a.drag(h)
                    }), !1), this.img.addEventListener("click", (function(h) {
                        return a.slide.classList.contains("dragging-nav") ? (a.zoomOut(), !1) : a.zoomedIn ? void(a.zoomedIn && !a.dragging && a.zoomOut()) : a.zoomIn()
                    }), !1), this.img.setZoomEvents = !0
                }), [{
                    key: "zoomIn",
                    value: function() {
                        var e = this.widowWidth();
                        if (!(this.zoomedIn || e <= 768)) {
                            var n = this.img;
                            if (n.setAttribute("data-style", n.getAttribute("style")), n.style.maxWidth = n.naturalWidth + "px", n.style.maxHeight = n.naturalHeight + "px", n.naturalWidth > e) {
                                var r = e / 2 - n.naturalWidth / 2;
                                this.setTranslate(this.img.parentNode, r, 0)
                            }
                            this.slide.classList.add("zoomed"), this.zoomedIn = !0
                        }
                    }
                }, {
                    key: "zoomOut",
                    value: function() {
                        this.img.parentNode.setAttribute("style", ""), this.img.setAttribute("style", this.img.getAttribute("data-style")), this.slide.classList.remove("zoomed"), this.zoomedIn = !1, this.currentX = null, this.currentY = null, this.initialX = null, this.initialY = null, this.xOffset = 0, this.yOffset = 0, this.onclose && typeof this.onclose == "function" && this.onclose()
                    }
                }, {
                    key: "dragStart",
                    value: function(e) {
                        e.preventDefault(), this.zoomedIn ? (e.type === "touchstart" ? (this.initialX = e.touches[0].clientX - this.xOffset, this.initialY = e.touches[0].clientY - this.yOffset) : (this.initialX = e.clientX - this.xOffset, this.initialY = e.clientY - this.yOffset), e.target === this.img && (this.active = !0, this.img.classList.add("dragging"))) : this.active = !1
                    }
                }, {
                    key: "dragEnd",
                    value: function(e) {
                        var n = this;
                        e.preventDefault(), this.initialX = this.currentX, this.initialY = this.currentY, this.active = !1, setTimeout((function() {
                            n.dragging = !1, n.img.isDragging = !1, n.img.classList.remove("dragging")
                        }), 100)
                    }
                }, {
                    key: "drag",
                    value: function(e) {
                        this.active && (e.preventDefault(), e.type === "touchmove" ? (this.currentX = e.touches[0].clientX - this.initialX, this.currentY = e.touches[0].clientY - this.initialY) : (this.currentX = e.clientX - this.initialX, this.currentY = e.clientY - this.initialY), this.xOffset = this.currentX, this.yOffset = this.currentY, this.img.isDragging = !0, this.dragging = !0, this.setTranslate(this.img, this.currentX, this.currentY))
                    }
                }, {
                    key: "onMove",
                    value: function(e) {
                        if (this.zoomedIn) {
                            var n = e.clientX - this.img.naturalWidth / 2,
                                r = e.clientY - this.img.naturalHeight / 2;
                            this.setTranslate(this.img, n, r)
                        }
                    }
                }, {
                    key: "setTranslate",
                    value: function(e, n, r) {
                        e.style.transform = "translate3d(" + n + "px, " + r + "px, 0)"
                    }
                }, {
                    key: "widowWidth",
                    value: function() {
                        return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
                    }
                }]),
                Xe = o((function e() {
                    var n = this,
                        r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                    i(this, e);
                    var a = r.dragEl,
                        l = r.toleranceX,
                        h = l === void 0 ? 40 : l,
                        u = r.toleranceY,
                        p = u === void 0 ? 65 : u,
                        b = r.slide,
                        y = b === void 0 ? null : b,
                        E = r.instance,
                        T = E === void 0 ? null : E;
                    this.el = a, this.active = !1, this.dragging = !1, this.currentX = null, this.currentY = null, this.initialX = null, this.initialY = null, this.xOffset = 0, this.yOffset = 0, this.direction = null, this.lastDirection = null, this.toleranceX = h, this.toleranceY = p, this.toleranceReached = !1, this.dragContainer = this.el, this.slide = y, this.instance = T, this.el.addEventListener("mousedown", (function(A) {
                        return n.dragStart(A)
                    }), !1), this.el.addEventListener("mouseup", (function(A) {
                        return n.dragEnd(A)
                    }), !1), this.el.addEventListener("mousemove", (function(A) {
                        return n.drag(A)
                    }), !1)
                }), [{
                    key: "dragStart",
                    value: function(e) {
                        if (this.slide.classList.contains("zoomed")) this.active = !1;
                        else {
                            e.type === "touchstart" ? (this.initialX = e.touches[0].clientX - this.xOffset, this.initialY = e.touches[0].clientY - this.yOffset) : (this.initialX = e.clientX - this.xOffset, this.initialY = e.clientY - this.yOffset);
                            var n = e.target.nodeName.toLowerCase();
                            e.target.classList.contains("nodrag") || L(e.target, ".nodrag") || ["input", "select", "textarea", "button", "a"].indexOf(n) !== -1 ? this.active = !1 : (e.preventDefault(), (e.target === this.el || n !== "img" && L(e.target, ".gslide-inline")) && (this.active = !0, this.el.classList.add("dragging"), this.dragContainer = L(e.target, ".ginner-container")))
                        }
                    }
                }, {
                    key: "dragEnd",
                    value: function(e) {
                        var n = this;
                        e && e.preventDefault(), this.initialX = 0, this.initialY = 0, this.currentX = null, this.currentY = null, this.initialX = null, this.initialY = null, this.xOffset = 0, this.yOffset = 0, this.active = !1, this.doSlideChange && (this.instance.preventOutsideClick = !0, this.doSlideChange == "right" && this.instance.prevSlide(), this.doSlideChange == "left" && this.instance.nextSlide()), this.doSlideClose && this.instance.close(), this.toleranceReached || this.setTranslate(this.dragContainer, 0, 0, !0), setTimeout((function() {
                            n.instance.preventOutsideClick = !1, n.toleranceReached = !1, n.lastDirection = null, n.dragging = !1, n.el.isDragging = !1, n.el.classList.remove("dragging"), n.slide.classList.remove("dragging-nav"), n.dragContainer.style.transform = "", n.dragContainer.style.transition = ""
                        }), 100)
                    }
                }, {
                    key: "drag",
                    value: function(e) {
                        if (this.active) {
                            e.preventDefault(), this.slide.classList.add("dragging-nav"), e.type === "touchmove" ? (this.currentX = e.touches[0].clientX - this.initialX, this.currentY = e.touches[0].clientY - this.initialY) : (this.currentX = e.clientX - this.initialX, this.currentY = e.clientY - this.initialY), this.xOffset = this.currentX, this.yOffset = this.currentY, this.el.isDragging = !0, this.dragging = !0, this.doSlideChange = !1, this.doSlideClose = !1;
                            var n = Math.abs(this.currentX),
                                r = Math.abs(this.currentY);
                            if (n > 0 && n >= Math.abs(this.currentY) && (!this.lastDirection || this.lastDirection == "x")) {
                                this.yOffset = 0, this.lastDirection = "x", this.setTranslate(this.dragContainer, this.currentX, 0);
                                var a = this.shouldChange();
                                if (!this.instance.settings.dragAutoSnap && a && (this.doSlideChange = a), this.instance.settings.dragAutoSnap && a) return this.instance.preventOutsideClick = !0, this.toleranceReached = !0, this.active = !1, this.instance.preventOutsideClick = !0, this.dragEnd(null), a == "right" && this.instance.prevSlide(), void(a == "left" && this.instance.nextSlide())
                            }
                            if (this.toleranceY > 0 && r > 0 && r >= n && (!this.lastDirection || this.lastDirection == "y")) {
                                this.xOffset = 0, this.lastDirection = "y", this.setTranslate(this.dragContainer, 0, this.currentY);
                                var l = this.shouldClose();
                                return !this.instance.settings.dragAutoSnap && l && (this.doSlideClose = !0), void(this.instance.settings.dragAutoSnap && l && this.instance.close())
                            }
                        }
                    }
                }, {
                    key: "shouldChange",
                    value: function() {
                        var e = !1;
                        if (Math.abs(this.currentX) >= this.toleranceX) {
                            var n = this.currentX > 0 ? "right" : "left";
                            (n == "left" && this.slide !== this.slide.parentNode.lastChild || n == "right" && this.slide !== this.slide.parentNode.firstChild) && (e = n)
                        }
                        return e
                    }
                }, {
                    key: "shouldClose",
                    value: function() {
                        var e = !1;
                        return Math.abs(this.currentY) >= this.toleranceY && (e = !0), e
                    }
                }, {
                    key: "setTranslate",
                    value: function(e, n, r) {
                        var a = arguments.length > 3 && arguments[3] !== void 0 && arguments[3];
                        e.style.transition = a ? "all .2s ease" : "", e.style.transform = "translate3d(".concat(n, "px, ").concat(r, "px, 0)")
                    }
                }]);

            function ft(e, n, r, a) {
                var l = e.querySelector(".gslide-media"),
                    h = new Image,
                    u = "gSlideTitle_" + r,
                    p = "gSlideDesc_" + r;
                h.addEventListener("load", (function() {
                    I(a) && a()
                }), !1), h.src = n.href, n.sizes != "" && n.srcset != "" && (h.sizes = n.sizes, h.srcset = n.srcset), h.alt = "", X(n.alt) || n.alt === "" || (h.alt = n.alt), n.title !== "" && h.setAttribute("aria-labelledby", u), n.description !== "" && h.setAttribute("aria-describedby", p), n.hasOwnProperty("_hasCustomWidth") && n._hasCustomWidth && (h.style.width = n.width), n.hasOwnProperty("_hasCustomHeight") && n._hasCustomHeight && (h.style.height = n.height), l.insertBefore(h, l.firstChild)
            }

            function mt(e, n, r, a) {
                var l = this,
                    h = e.querySelector(".ginner-container"),
                    u = "gvideo" + r,
                    p = e.querySelector(".gslide-media"),
                    b = this.getAllPlayers();
                w(h, "gvideo-container"), p.insertBefore(se('<div class="gvideo-wrapper"></div>'), p.firstChild);
                var y = e.querySelector(".gvideo-wrapper");
                Ne(this.settings.plyr.css, "Plyr");
                var E = n.href,
                    T = n?.videoProvider,
                    A = !1;
                p.style.maxWidth = n.width, Ne(this.settings.plyr.js, "Plyr", (function() {
                    if (!T && E.match(/vimeo\.com\/([0-9]*)/) && (T = "vimeo"), !T && (E.match(/(youtube\.com|youtube-nocookie\.com)\/watch\?v=([a-zA-Z0-9\-_]+)/) || E.match(/youtu\.be\/([a-zA-Z0-9\-_]+)/) || E.match(/(youtube\.com|youtube-nocookie\.com)\/embed\/([a-zA-Z0-9\-_]+)/) || E.match(/(youtube\.com|youtube-nocookie\.com)\/shorts\/([a-zA-Z0-9\-_]+)/)) && (T = "youtube"), T === "local" || !T) {
                        T = "local";
                        var q = '<video id="' + u + '" ';
                        q += 'style="background:#000; max-width: '.concat(n.width, ';" '), q += 'preload="metadata" ', q += 'x-webkit-airplay="allow" ', q += "playsinline ", q += "controls ", q += 'class="gvideo-local">', q += '<source src="'.concat(E, '">'), A = se(q += "</video>")
                    }
                    var _ = A || se('<div id="'.concat(u, '" data-plyr-provider="').concat(T, '" data-plyr-embed-id="').concat(E, '"></div>'));
                    w(y, "".concat(T, "-video gvideo")), y.appendChild(_), y.setAttribute("data-id", u), y.setAttribute("data-index", r);
                    var D = H(l.settings.plyr, "config") ? l.settings.plyr.config : {},
                        W = new Plyr("#" + u, D);
                    W.on("ready", (function(V) {
                        b[u] = V.detail.plyr, I(a) && a()
                    })), ke((function() {
                        return e.querySelector("iframe") && e.querySelector("iframe").dataset.ready == "true"
                    }), (function() {
                        l.resize(e)
                    })), W.on("enterfullscreen", Ve), W.on("exitfullscreen", Ve)
                }))
            }

            function Ve(e) {
                var n = L(e.target, ".gslide-media");
                e.type === "enterfullscreen" && w(n, "fullscreen"), e.type === "exitfullscreen" && x(n, "fullscreen")
            }

            function vt(e, n, r, a) {
                var l, h = this,
                    u = e.querySelector(".gslide-media"),
                    p = !(!H(n, "href") || !n.href) && n.href.split("#").pop().trim(),
                    b = !(!H(n, "content") || !n.content) && n.content;
                if (b && (pe(b) && (l = se('<div class="ginlined-content">'.concat(b, "</div>"))), Z(b))) {
                    b.style.display == "none" && (b.style.display = "block");
                    var y = document.createElement("div");
                    y.className = "ginlined-content", y.appendChild(b), l = y
                }
                if (p) {
                    var E = document.getElementById(p);
                    if (!E) return !1;
                    var T = E.cloneNode(!0);
                    T.style.height = n.height, T.style.maxWidth = n.width, w(T, "ginlined-content"), l = T
                }
                if (!l) return console.error("Unable to append inline slide content", n), !1;
                u.style.height = n.height, u.style.width = n.width, u.appendChild(l), this.events["inlineclose" + p] = S("click", {
                    onElement: u.querySelectorAll(".gtrigger-close"),
                    withCallback: function(A) {
                        A.preventDefault(), h.close()
                    }
                }), I(a) && a()
            }

            function yt(e, n, r, a) {
                var l = e.querySelector(".gslide-media"),
                    h = (function(u) {
                        var p = u.url,
                            b = u.allow,
                            y = u.callback,
                            E = u.appendTo,
                            T = document.createElement("iframe");
                        return T.className = "vimeo-video gvideo", T.src = p, T.style.width = "100%", T.style.height = "100%", b && T.setAttribute("allow", b), T.onload = function() {
                            T.onload = null, w(T, "node-ready"), I(y) && y()
                        }, E && E.appendChild(T), T
                    })({
                        url: n.href,
                        callback: a
                    });
                l.parentNode.style.maxWidth = n.width, l.parentNode.style.height = n.height, l.appendChild(h)
            }
            var wt = o((function e() {
                    var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                    i(this, e), this.defaults = {
                        href: "",
                        sizes: "",
                        srcset: "",
                        title: "",
                        type: "",
                        videoProvider: "",
                        description: "",
                        alt: "",
                        descPosition: "bottom",
                        effect: "",
                        width: "",
                        height: "",
                        content: !1,
                        zoomable: !0,
                        draggable: !0
                    }, le(n) && (this.defaults = v(this.defaults, n))
                }), [{
                    key: "sourceType",
                    value: function(e) {
                        var n = e;
                        return (e = e.toLowerCase()).match(/\.(jpeg|jpg|jpe|gif|png|apn|webp|avif|svg)/) !== null ? "image" : e.match(/(youtube\.com|youtube-nocookie\.com)\/watch\?v=([a-zA-Z0-9\-_]+)/) || e.match(/youtu\.be\/([a-zA-Z0-9\-_]+)/) || e.match(/(youtube\.com|youtube-nocookie\.com)\/embed\/([a-zA-Z0-9\-_]+)/) || e.match(/(youtube\.com|youtube-nocookie\.com)\/shorts\/([a-zA-Z0-9\-_]+)/) || e.match(/vimeo\.com\/([0-9]*)/) || e.match(/\.(mp4|ogg|webm|mov)/) !== null ? "video" : e.match(/\.(mp3|wav|wma|aac|ogg)/) !== null ? "audio" : e.indexOf("#") > -1 && n.split("#").pop().trim() !== "" ? "inline" : e.indexOf("goajax=true") > -1 ? "ajax" : "external"
                    }
                }, {
                    key: "parseConfig",
                    value: function(e, n) {
                        var r = this,
                            a = v({
                                descPosition: n.descPosition
                            }, this.defaults);
                        if (le(e) && !Z(e)) {
                            H(e, "type") || (H(e, "content") && e.content ? e.type = "inline" : H(e, "href") && (e.type = this.sourceType(e.href)));
                            var l = v(a, e);
                            return this.setSize(l, n), l
                        }
                        var h = "",
                            u = e.getAttribute("data-glightbox"),
                            p = e.nodeName.toLowerCase();
                        if (p === "a" && (h = e.href), p === "img" && (h = e.src, a.alt = e.alt), a.href = h, m(a, (function(q, _) {
                                H(n, _) && _ !== "width" && (a[_] = n[_]);
                                var D = e.dataset[_];
                                X(D) || (a[_] = r.sanitizeValue(D))
                            })), a.content && (a.type = "inline"), !a.type && h && (a.type = this.sourceType(h)), X(u)) {
                            if (!a.title && p == "a") {
                                var b = e.title;
                                X(b) || b === "" || (a.title = b)
                            }
                            if (!a.title && p == "img") {
                                var y = e.alt;
                                X(y) || y === "" || (a.title = y)
                            }
                        } else {
                            var E = [];
                            m(a, (function(q, _) {
                                E.push(";\\s?" + _)
                            })), E = E.join("\\s?:|"), u.trim() !== "" && m(a, (function(q, _) {
                                var D = u,
                                    W = new RegExp("s?" + _ + "s?:s?(.*?)(" + E + "s?:|$)"),
                                    V = D.match(W);
                                if (V && V.length && V[1]) {
                                    var Q = V[1].trim().replace(/;\s*$/, "");
                                    a[_] = r.sanitizeValue(Q)
                                }
                            }))
                        }
                        if (a.description && a.description.substring(0, 1) === ".") {
                            var T;
                            try {
                                T = document.querySelector(a.description).innerHTML
                            } catch (q) {
                                if (!(q instanceof DOMException)) throw q
                            }
                            T && (a.description = T)
                        }
                        if (!a.description) {
                            var A = e.querySelector(".glightbox-desc");
                            A && (a.description = A.innerHTML)
                        }
                        return this.setSize(a, n, e), this.slideConfig = a, a
                    }
                }, {
                    key: "setSize",
                    value: function(e, n) {
                        var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null,
                            a = e.type == "video" ? this.checkSize(n.videosWidth) : this.checkSize(n.width),
                            l = this.checkSize(n.height);
                        return e.width = H(e, "width") && e.width !== "" ? this.checkSize(e.width) : a, e.height = H(e, "height") && e.height !== "" ? this.checkSize(e.height) : l, r && e.type == "image" && (e._hasCustomWidth = !!r.dataset.width, e._hasCustomHeight = !!r.dataset.height), e
                    }
                }, {
                    key: "checkSize",
                    value: function(e) {
                        return me(e) ? "".concat(e, "px") : e
                    }
                }, {
                    key: "sanitizeValue",
                    value: function(e) {
                        return e !== "true" && e !== "false" ? e : e === "true"
                    }
                }]),
                ve = o((function e(n, r, a) {
                    i(this, e), this.element = n, this.instance = r, this.index = a
                }), [{
                    key: "setContent",
                    value: function() {
                        var e = this,
                            n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null,
                            r = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
                        if (C(n, "loaded")) return !1;
                        var a = this.instance.settings,
                            l = this.slideConfig,
                            h = Ae();
                        I(a.beforeSlideLoad) && a.beforeSlideLoad({
                            index: this.index,
                            slide: n,
                            player: !1
                        });
                        var u = l.type,
                            p = l.descPosition,
                            b = n.querySelector(".gslide-media"),
                            y = n.querySelector(".gslide-title"),
                            E = n.querySelector(".gslide-desc"),
                            T = n.querySelector(".gdesc-inner"),
                            A = r,
                            q = "gSlideTitle_" + this.index,
                            _ = "gSlideDesc_" + this.index;
                        if (I(a.afterSlideLoad) && (A = function() {
                                I(r) && r(), a.afterSlideLoad({
                                    index: e.index,
                                    slide: n,
                                    player: e.instance.getSlidePlayerInstance(e.index)
                                })
                            }), l.title == "" && l.description == "" ? T && T.parentNode.parentNode.removeChild(T.parentNode) : (y && l.title !== "" ? (y.id = q, y.innerHTML = l.title) : y.parentNode.removeChild(y), E && l.description !== "" ? (E.id = _, h && a.moreLength > 0 ? (l.smallDescription = this.slideShortDesc(l.description, a.moreLength, a.moreText), E.innerHTML = l.smallDescription, this.descriptionEvents(E, l)) : E.innerHTML = l.description) : E.parentNode.removeChild(E), w(b.parentNode, "desc-".concat(p)), w(T.parentNode, "description-".concat(p))), w(b, "gslide-".concat(u)), w(n, "loaded"), u !== "video") {
                            if (u !== "external") return u === "inline" ? (vt.apply(this.instance, [n, l, this.index, A]), void(l.draggable && new Xe({
                                dragEl: n.querySelector(".gslide-inline"),
                                toleranceX: a.dragToleranceX,
                                toleranceY: a.dragToleranceY,
                                slide: n,
                                instance: this.instance
                            }))) : void(u !== "image" ? I(A) && A() : ft(n, l, this.index, (function() {
                                var D = n.querySelector("img");
                                l.draggable && new Xe({
                                    dragEl: D,
                                    toleranceX: a.dragToleranceX,
                                    toleranceY: a.dragToleranceY,
                                    slide: n,
                                    instance: e.instance
                                }), l.zoomable && D.naturalWidth > D.offsetWidth && (w(D, "zoomable"), new gt(D, n, (function() {
                                    e.instance.resize()
                                }))), I(A) && A()
                            })));
                            yt.apply(this, [n, l, this.index, A])
                        } else mt.apply(this.instance, [n, l, this.index, A])
                    }
                }, {
                    key: "slideShortDesc",
                    value: function(e) {
                        var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 50,
                            r = arguments.length > 2 && arguments[2] !== void 0 && arguments[2],
                            a = document.createElement("div");
                        a.innerHTML = e;
                        var l = a.innerText,
                            h = r;
                        if ((e = l.trim()).length <= n) return e;
                        var u = e.substr(0, n - 1);
                        return h ? (a = null, u + '... <a href="#" class="desc-more">' + r + "</a>") : u
                    }
                }, {
                    key: "descriptionEvents",
                    value: function(e, n) {
                        var r = this,
                            a = e.querySelector(".desc-more");
                        if (!a) return !1;
                        S("click", {
                            onElement: a,
                            withCallback: function(l, h) {
                                l.preventDefault();
                                var u = document.body,
                                    p = L(h, ".gslide-desc");
                                if (!p) return !1;
                                p.innerHTML = n.description, w(u, "gdesc-open");
                                var b = S("click", {
                                    onElement: [u, L(p, ".gslide-description")],
                                    withCallback: function(y, E) {
                                        y.target.nodeName.toLowerCase() !== "a" && (x(u, "gdesc-open"), w(u, "gdesc-closed"), p.innerHTML = n.smallDescription, r.descriptionEvents(p, n), setTimeout((function() {
                                            x(u, "gdesc-closed")
                                        }), 400), b.destroy())
                                    }
                                })
                            }
                        })
                    }
                }, {
                    key: "create",
                    value: function() {
                        return se(this.instance.settings.slideHTML)
                    }
                }, {
                    key: "getConfig",
                    value: function() {
                        Z(this.element) || this.element.hasOwnProperty("draggable") || (this.element.draggable = this.instance.settings.draggable);
                        var e = new wt(this.instance.settings.slideExtraAttributes);
                        return this.slideConfig = e.parseConfig(this.element, this.instance.settings), this.slideConfig
                    }
                }]);

            function ye(e) {
                return Math.sqrt(e.x * e.x + e.y * e.y)
            }

            function bt(e, n) {
                var r = (function(a, l) {
                    var h = ye(a) * ye(l);
                    if (h === 0) return 0;
                    var u = (function(p, b) {
                        return p.x * b.x + p.y * b.y
                    })(a, l) / h;
                    return u > 1 && (u = 1), Math.acos(u)
                })(e, n);
                return (function(a, l) {
                    return a.x * l.y - l.x * a.y
                })(e, n) > 0 && (r *= -1), 180 * r / Math.PI
            }
            var St = o((function e(n) {
                i(this, e), this.handlers = [], this.el = n
            }), [{
                key: "add",
                value: function(e) {
                    this.handlers.push(e)
                }
            }, {
                key: "del",
                value: function(e) {
                    e || (this.handlers = []);
                    for (var n = this.handlers.length; n >= 0; n--) this.handlers[n] === e && this.handlers.splice(n, 1)
                }
            }, {
                key: "dispatch",
                value: function() {
                    for (var e = 0, n = this.handlers.length; e < n; e++) {
                        var r = this.handlers[e];
                        typeof r == "function" && r.apply(this.el, arguments)
                    }
                }
            }]);

            function Y(e, n) {
                var r = new St(e);
                return r.add(n), r
            }
            var xt = o((function e(n, r) {
                i(this, e), this.element = typeof n == "string" ? document.querySelector(n) : n, this.start = this.start.bind(this), this.move = this.move.bind(this), this.end = this.end.bind(this), this.cancel = this.cancel.bind(this), this.element.addEventListener("touchstart", this.start, !1), this.element.addEventListener("touchmove", this.move, !1), this.element.addEventListener("touchend", this.end, !1), this.element.addEventListener("touchcancel", this.cancel, !1), this.preV = {
                    x: null,
                    y: null
                }, this.pinchStartLen = null, this.zoom = 1, this.isDoubleTap = !1;
                var a = function() {};
                this.rotate = Y(this.element, r.rotate || a), this.touchStart = Y(this.element, r.touchStart || a), this.multipointStart = Y(this.element, r.multipointStart || a), this.multipointEnd = Y(this.element, r.multipointEnd || a), this.pinch = Y(this.element, r.pinch || a), this.swipe = Y(this.element, r.swipe || a), this.tap = Y(this.element, r.tap || a), this.doubleTap = Y(this.element, r.doubleTap || a), this.longTap = Y(this.element, r.longTap || a), this.singleTap = Y(this.element, r.singleTap || a), this.pressMove = Y(this.element, r.pressMove || a), this.twoFingerPressMove = Y(this.element, r.twoFingerPressMove || a), this.touchMove = Y(this.element, r.touchMove || a), this.touchEnd = Y(this.element, r.touchEnd || a), this.touchCancel = Y(this.element, r.touchCancel || a), this.translateContainer = this.element, this._cancelAllHandler = this.cancelAll.bind(this), window.addEventListener("scroll", this._cancelAllHandler), this.delta = null, this.last = null, this.now = null, this.tapTimeout = null, this.singleTapTimeout = null, this.longTapTimeout = null, this.swipeTimeout = null, this.x1 = this.x2 = this.y1 = this.y2 = null, this.preTapPosition = {
                    x: null,
                    y: null
                }
            }), [{
                key: "start",
                value: function(e) {
                    if (e.touches)
                        if (e.target && e.target.nodeName && ["a", "button", "input"].indexOf(e.target.nodeName.toLowerCase()) >= 0) console.log("ignore drag for this touched element", e.target.nodeName.toLowerCase());
                        else {
                            this.now = Date.now(), this.x1 = e.touches[0].pageX, this.y1 = e.touches[0].pageY, this.delta = this.now - (this.last || this.now), this.touchStart.dispatch(e, this.element), this.preTapPosition.x !== null && (this.isDoubleTap = this.delta > 0 && this.delta <= 250 && Math.abs(this.preTapPosition.x - this.x1) < 30 && Math.abs(this.preTapPosition.y - this.y1) < 30, this.isDoubleTap && clearTimeout(this.singleTapTimeout)), this.preTapPosition.x = this.x1, this.preTapPosition.y = this.y1, this.last = this.now;
                            var n = this.preV;
                            if (e.touches.length > 1) {
                                this._cancelLongTap(), this._cancelSingleTap();
                                var r = {
                                    x: e.touches[1].pageX - this.x1,
                                    y: e.touches[1].pageY - this.y1
                                };
                                n.x = r.x, n.y = r.y, this.pinchStartLen = ye(n), this.multipointStart.dispatch(e, this.element)
                            }
                            this._preventTap = !1, this.longTapTimeout = setTimeout(function() {
                                this.longTap.dispatch(e, this.element), this._preventTap = !0
                            }.bind(this), 750)
                        }
                }
            }, {
                key: "move",
                value: function(e) {
                    if (e.touches) {
                        var n = this.preV,
                            r = e.touches.length,
                            a = e.touches[0].pageX,
                            l = e.touches[0].pageY;
                        if (this.isDoubleTap = !1, r > 1) {
                            var h = e.touches[1].pageX,
                                u = e.touches[1].pageY,
                                p = {
                                    x: e.touches[1].pageX - a,
                                    y: e.touches[1].pageY - l
                                };
                            n.x !== null && (this.pinchStartLen > 0 && (e.zoom = ye(p) / this.pinchStartLen, this.pinch.dispatch(e, this.element)), e.angle = bt(p, n), this.rotate.dispatch(e, this.element)), n.x = p.x, n.y = p.y, this.x2 !== null && this.sx2 !== null ? (e.deltaX = (a - this.x2 + h - this.sx2) / 2, e.deltaY = (l - this.y2 + u - this.sy2) / 2) : (e.deltaX = 0, e.deltaY = 0), this.twoFingerPressMove.dispatch(e, this.element), this.sx2 = h, this.sy2 = u
                        } else {
                            if (this.x2 !== null) {
                                e.deltaX = a - this.x2, e.deltaY = l - this.y2;
                                var b = Math.abs(this.x1 - this.x2),
                                    y = Math.abs(this.y1 - this.y2);
                                (b > 10 || y > 10) && (this._preventTap = !0)
                            } else e.deltaX = 0, e.deltaY = 0;
                            this.pressMove.dispatch(e, this.element)
                        }
                        this.touchMove.dispatch(e, this.element), this._cancelLongTap(), this.x2 = a, this.y2 = l, r > 1 && e.preventDefault()
                    }
                }
            }, {
                key: "end",
                value: function(e) {
                    if (e.changedTouches) {
                        this._cancelLongTap();
                        var n = this;
                        e.touches.length < 2 && (this.multipointEnd.dispatch(e, this.element), this.sx2 = this.sy2 = null), this.x2 && Math.abs(this.x1 - this.x2) > 30 || this.y2 && Math.abs(this.y1 - this.y2) > 30 ? (e.direction = this._swipeDirection(this.x1, this.x2, this.y1, this.y2), this.swipeTimeout = setTimeout((function() {
                            n.swipe.dispatch(e, n.element)
                        }), 0)) : (this.tapTimeout = setTimeout((function() {
                            n._preventTap || n.tap.dispatch(e, n.element), n.isDoubleTap && (n.doubleTap.dispatch(e, n.element), n.isDoubleTap = !1)
                        }), 0), n.isDoubleTap || (n.singleTapTimeout = setTimeout((function() {
                            n.singleTap.dispatch(e, n.element)
                        }), 250))), this.touchEnd.dispatch(e, this.element), this.preV.x = 0, this.preV.y = 0, this.zoom = 1, this.pinchStartLen = null, this.x1 = this.x2 = this.y1 = this.y2 = null
                    }
                }
            }, {
                key: "cancelAll",
                value: function() {
                    this._preventTap = !0, clearTimeout(this.singleTapTimeout), clearTimeout(this.tapTimeout), clearTimeout(this.longTapTimeout), clearTimeout(this.swipeTimeout)
                }
            }, {
                key: "cancel",
                value: function(e) {
                    this.cancelAll(), this.touchCancel.dispatch(e, this.element)
                }
            }, {
                key: "_cancelLongTap",
                value: function() {
                    clearTimeout(this.longTapTimeout)
                }
            }, {
                key: "_cancelSingleTap",
                value: function() {
                    clearTimeout(this.singleTapTimeout)
                }
            }, {
                key: "_swipeDirection",
                value: function(e, n, r, a) {
                    return Math.abs(e - n) >= Math.abs(r - a) ? e - n > 0 ? "Left" : "Right" : r - a > 0 ? "Up" : "Down"
                }
            }, {
                key: "on",
                value: function(e, n) {
                    this[e] && this[e].add(n)
                }
            }, {
                key: "off",
                value: function(e, n) {
                    this[e] && this[e].del(n)
                }
            }, {
                key: "destroy",
                value: function() {
                    return this.singleTapTimeout && clearTimeout(this.singleTapTimeout), this.tapTimeout && clearTimeout(this.tapTimeout), this.longTapTimeout && clearTimeout(this.longTapTimeout), this.swipeTimeout && clearTimeout(this.swipeTimeout), this.element.removeEventListener("touchstart", this.start), this.element.removeEventListener("touchmove", this.move), this.element.removeEventListener("touchend", this.end), this.element.removeEventListener("touchcancel", this.cancel), this.rotate.del(), this.touchStart.del(), this.multipointStart.del(), this.multipointEnd.del(), this.pinch.del(), this.swipe.del(), this.tap.del(), this.doubleTap.del(), this.longTap.del(), this.singleTap.del(), this.pressMove.del(), this.twoFingerPressMove.del(), this.touchMove.del(), this.touchEnd.del(), this.touchCancel.del(), this.preV = this.pinchStartLen = this.zoom = this.isDoubleTap = this.delta = this.last = this.now = this.tapTimeout = this.singleTapTimeout = this.longTapTimeout = this.swipeTimeout = this.x1 = this.x2 = this.y1 = this.y2 = this.preTapPosition = this.rotate = this.touchStart = this.multipointStart = this.multipointEnd = this.pinch = this.swipe = this.tap = this.doubleTap = this.longTap = this.singleTap = this.pressMove = this.touchMove = this.touchEnd = this.touchCancel = this.twoFingerPressMove = null, window.removeEventListener("scroll", this._cancelAllHandler), null
                }
            }]);

            function qe(e) {
                var n = (function() {
                        var u, p = document.createElement("fakeelement"),
                            b = {
                                transition: "transitionend",
                                OTransition: "oTransitionEnd",
                                MozTransition: "transitionend",
                                WebkitTransition: "webkitTransitionEnd"
                            };
                        for (u in b)
                            if (p.style[u] !== void 0) return b[u]
                    })(),
                    r = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
                    a = C(e, "gslide-media") ? e : e.querySelector(".gslide-media"),
                    l = L(a, ".ginner-container"),
                    h = e.querySelector(".gslide-description");
                r > 769 && (a = l), w(a, "greset"), N(a, "translate3d(0, 0, 0)"), S(n, {
                    onElement: a,
                    once: !0,
                    withCallback: function(u, p) {
                        x(a, "greset")
                    }
                }), a.style.opacity = "", h && (h.style.opacity = "")
            }

            function Et(e) {
                if (e.events.hasOwnProperty("touch")) return !1;
                var n, r, a, l = He(),
                    h = l.width,
                    u = l.height,
                    p = !1,
                    b = null,
                    y = null,
                    E = null,
                    T = !1,
                    A = 1,
                    q = 1,
                    _ = !1,
                    D = !1,
                    W = null,
                    V = null,
                    Q = null,
                    B = null,
                    J = 0,
                    ee = 0,
                    ge = !1,
                    ce = !1,
                    G = {},
                    K = {},
                    Ge = 0,
                    Ke = 0,
                    kt = document.getElementById("glightbox-slider"),
                    we = document.querySelector(".goverlay"),
                    At = new xt(kt, {
                        touchStart: function($) {
                            if (p = !0, (C($.targetTouches[0].target, "ginner-container") || L($.targetTouches[0].target, ".gslide-desc") || $.targetTouches[0].target.nodeName.toLowerCase() == "a") && (p = !1), L($.targetTouches[0].target, ".gslide-inline") && !C($.targetTouches[0].target.parentNode, "gslide-inline") && (p = !1), p) {
                                if (K = $.targetTouches[0], G.pageX = $.targetTouches[0].pageX, G.pageY = $.targetTouches[0].pageY, Ge = $.targetTouches[0].clientX, Ke = $.targetTouches[0].clientY, b = e.activeSlide, y = b.querySelector(".gslide-media"), a = b.querySelector(".gslide-inline"), E = null, C(y, "gslide-image") && (E = y.querySelector("img")), (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) > 769 && (y = b.querySelector(".ginner-container")), x(we, "greset"), $.pageX > 20 && $.pageX < window.innerWidth - 20) return;
                                $.preventDefault()
                            }
                        },
                        touchMove: function($) {
                            if (p && (K = $.targetTouches[0], !_ && !D)) {
                                if (a && a.offsetHeight > u) {
                                    var R = G.pageX - K.pageX;
                                    if (Math.abs(R) <= 13) return !1
                                }
                                T = !0;
                                var te, be = $.targetTouches[0].clientX,
                                    qt = $.targetTouches[0].clientY,
                                    Lt = Ge - be,
                                    _t = Ke - qt;
                                if (Math.abs(Lt) > Math.abs(_t) ? (ge = !1, ce = !0) : (ce = !1, ge = !0), n = K.pageX - G.pageX, J = 100 * n / h, r = K.pageY - G.pageY, ee = 100 * r / u, ge && E && (te = 1 - Math.abs(r) / u, we.style.opacity = te, e.settings.touchFollowAxis && (J = 0)), ce && (te = 1 - Math.abs(n) / h, y.style.opacity = te, e.settings.touchFollowAxis && (ee = 0)), !E) return N(y, "translate3d(".concat(J, "%, 0, 0)"));
                                N(y, "translate3d(".concat(J, "%, ").concat(ee, "%, 0)"))
                            }
                        },
                        touchEnd: function() {
                            if (p) {
                                if (T = !1, D || _) return Q = W, void(B = V);
                                var $ = Math.abs(parseInt(ee)),
                                    R = Math.abs(parseInt(J));
                                if (!($ > 29 && E)) return $ < 29 && R < 25 ? (w(we, "greset"), we.style.opacity = 1, qe(y)) : void 0;
                                e.close()
                            }
                        },
                        multipointEnd: function() {
                            setTimeout((function() {
                                _ = !1
                            }), 50)
                        },
                        multipointStart: function() {
                            _ = !0, A = q || 1
                        },
                        pinch: function($) {
                            if (!E || T) return !1;
                            _ = !0, E.scaleX = E.scaleY = A * $.zoom;
                            var R = A * $.zoom;
                            if (D = !0, R <= 1) return D = !1, R = 1, B = null, Q = null, W = null, V = null, void E.setAttribute("style", "");
                            R > 4.5 && (R = 4.5), E.style.transform = "scale3d(".concat(R, ", ").concat(R, ", 1)"), q = R
                        },
                        pressMove: function($) {
                            if (D && !_) {
                                var R = K.pageX - G.pageX,
                                    te = K.pageY - G.pageY;
                                Q && (R += Q), B && (te += B), W = R, V = te;
                                var be = "translate3d(".concat(R, "px, ").concat(te, "px, 0)");
                                q && (be += " scale3d(".concat(q, ", ").concat(q, ", 1)")), N(E, be)
                            }
                        },
                        swipe: function($) {
                            if (!D)
                                if (_) _ = !1;
                                else {
                                    if ($.direction == "Left") {
                                        if (e.index == e.elements.length - 1) return qe(y);
                                        e.nextSlide()
                                    }
                                    if ($.direction == "Right") {
                                        if (e.index == 0) return qe(y);
                                        e.prevSlide()
                                    }
                                }
                        }
                    });
                e.events.touch = At
            }
            var je = Ae(),
                We = Ae() !== null || document.createTouch !== void 0 || "ontouchstart" in window || "onmsgesturechange" in window || navigator.msMaxTouchPoints,
                Ue = document.getElementsByTagName("html")[0],
                Ct = {
                    selector: ".glightbox",
                    elements: null,
                    skin: "clean",
                    theme: "clean",
                    closeButton: !0,
                    startAt: null,
                    autoplayVideos: !0,
                    autofocusVideos: !0,
                    descPosition: "bottom",
                    width: "900px",
                    height: "506px",
                    videosWidth: "960px",
                    beforeSlideChange: null,
                    afterSlideChange: null,
                    beforeSlideLoad: null,
                    afterSlideLoad: null,
                    slideInserted: null,
                    slideRemoved: null,
                    slideExtraAttributes: null,
                    onOpen: null,
                    onClose: null,
                    loop: !1,
                    zoomable: !0,
                    draggable: !0,
                    dragAutoSnap: !1,
                    dragToleranceX: 40,
                    dragToleranceY: 65,
                    preload: !0,
                    oneSlidePerOpen: !1,
                    touchNavigation: !0,
                    touchFollowAxis: !0,
                    keyboardNavigation: !0,
                    closeOnOutsideClick: !0,
                    plugins: !1,
                    plyr: {
                        css: "https://cdn.plyr.io/3.6.12/plyr.css",
                        js: "https://cdn.plyr.io/3.6.12/plyr.js",
                        config: {
                            ratio: "16:9",
                            fullscreen: {
                                enabled: !0,
                                iosNative: !0
                            },
                            youtube: {
                                noCookie: !0,
                                rel: 0,
                                showinfo: 0,
                                iv_load_policy: 3
                            },
                            vimeo: {
                                byline: !1,
                                portrait: !1,
                                title: !1,
                                transparent: !1
                            }
                        }
                    },
                    openEffect: "zoom",
                    closeEffect: "zoom",
                    slideEffect: "slide",
                    moreText: "See more",
                    moreLength: 60,
                    cssEfects: {
                        fade: {
                            in: "fadeIn",
                            out: "fadeOut"
                        },
                        zoom: {
                            in: "zoomIn",
                            out: "zoomOut"
                        },
                        slide: {
                            in: "slideInRight",
                            out: "slideOutLeft"
                        },
                        slideBack: {
                            in: "slideInLeft",
                            out: "slideOutRight"
                        },
                        none: {
                            in: "none",
                            out: "none"
                        }
                    },
                    svg: {
                        close: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" xml:space="preserve"><g><g><path d="M505.943,6.058c-8.077-8.077-21.172-8.077-29.249,0L6.058,476.693c-8.077,8.077-8.077,21.172,0,29.249C10.096,509.982,15.39,512,20.683,512c5.293,0,10.586-2.019,14.625-6.059L505.943,35.306C514.019,27.23,514.019,14.135,505.943,6.058z"/></g></g><g><g><path d="M505.942,476.694L35.306,6.059c-8.076-8.077-21.172-8.077-29.248,0c-8.077,8.076-8.077,21.171,0,29.248l470.636,470.636c4.038,4.039,9.332,6.058,14.625,6.058c5.293,0,10.587-2.019,14.624-6.057C514.018,497.866,514.018,484.771,505.942,476.694z"/></g></g></svg>',
                        next: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 477.175 477.175" xml:space="preserve"> <g><path d="M360.731,229.075l-225.1-225.1c-5.3-5.3-13.8-5.3-19.1,0s-5.3,13.8,0,19.1l215.5,215.5l-215.5,215.5c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4c3.4,0,6.9-1.3,9.5-4l225.1-225.1C365.931,242.875,365.931,234.275,360.731,229.075z"/></g></svg>',
                        prev: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 477.175 477.175" xml:space="preserve"><g><path d="M145.188,238.575l215.5-215.5c5.3-5.3,5.3-13.8,0-19.1s-13.8-5.3-19.1,0l-225.1,225.1c-5.3,5.3-5.3,13.8,0,19.1l225.1,225c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1L145.188,238.575z"/></g></svg>'
                    },
                    slideHTML: `<div class="gslide">
    <div class="gslide-inner-content">
        <div class="ginner-container">
            <div class="gslide-media">
            </div>
            <div class="gslide-description">
                <div class="gdesc-inner">
                    <h4 class="gslide-title"></h4>
                    <div class="gslide-desc"></div>
                </div>
            </div>
        </div>
    </div>
</div>`,
                    lightboxHTML: `<div id="glightbox-body" class="glightbox-container" tabindex="-1" role="dialog" aria-hidden="false">
    <div class="gloader visible"></div>
    <div class="goverlay"></div>
    <div class="gcontainer">
    <div id="glightbox-slider" class="gslider"></div>
    <button class="gclose gbtn" aria-label="Close" data-taborder="3">{closeSVG}</button>
    <button class="gprev gbtn" aria-label="Previous" data-taborder="2">{prevSVG}</button>
    <button class="gnext gbtn" aria-label="Next" data-taborder="1">{nextSVG}</button>
</div>
</div>`
                },
                Tt = o((function e() {
                    var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                    i(this, e), this.customOptions = n, this.settings = v(Ct, n), this.effectsClasses = this.getAnimationClasses(), this.videoPlayers = {}, this.apiEvents = [], this.fullElementsList = !1
                }), [{
                    key: "init",
                    value: function() {
                        var e = this,
                            n = this.getSelector();
                        n && (this.baseEvents = S("click", {
                            onElement: n,
                            withCallback: function(r, a) {
                                r.preventDefault(), e.open(a)
                            }
                        })), this.elements = this.getElements()
                    }
                }, {
                    key: "open",
                    value: function() {
                        var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null,
                            n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                        if (this.elements.length === 0) return !1;
                        this.activeSlide = null, this.prevActiveSlideIndex = null, this.prevActiveSlide = null;
                        var r = me(n) ? n : this.settings.startAt;
                        if (Z(e)) {
                            var a = e.getAttribute("data-gallery");
                            a && (this.fullElementsList = this.elements, this.elements = this.getGalleryElements(this.elements, a)), X(r) && (r = this.getElementIndex(e)) < 0 && (r = 0)
                        }
                        me(r) || (r = 0), this.build(), z(this.overlay, this.settings.openEffect === "none" ? "none" : this.settings.cssEfects.fade.in);
                        var l = document.body,
                            h = window.innerWidth - document.documentElement.clientWidth;
                        if (h > 0) {
                            var u = document.createElement("style");
                            u.type = "text/css", u.className = "gcss-styles", u.innerText = ".gscrollbar-fixer {margin-right: ".concat(h, "px}"), document.head.appendChild(u), w(l, "gscrollbar-fixer")
                        }
                        w(l, "glightbox-open"), w(Ue, "glightbox-open"), je && (w(document.body, "glightbox-mobile"), this.settings.slideEffect = "slide"), this.showSlide(r, !0), this.elements.length === 1 ? (w(this.prevButton, "glightbox-button-hidden"), w(this.nextButton, "glightbox-button-hidden")) : (x(this.prevButton, "glightbox-button-hidden"), x(this.nextButton, "glightbox-button-hidden")), this.lightboxOpen = !0, this.trigger("open"), I(this.settings.onOpen) && this.settings.onOpen(), We && this.settings.touchNavigation && Et(this), this.settings.keyboardNavigation && pt(this)
                    }
                }, {
                    key: "openAt",
                    value: function() {
                        var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
                        this.open(null, e)
                    }
                }, {
                    key: "showSlide",
                    value: function() {
                        var e = this,
                            n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0,
                            r = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
                        ie(this.loader), this.index = parseInt(n);
                        var a = this.slidesContainer.querySelector(".current");
                        a && x(a, "current"), this.slideAnimateOut();
                        var l = this.slidesContainer.querySelectorAll(".gslide")[n];
                        if (C(l, "loaded")) this.slideAnimateIn(l, r), ne(this.loader);
                        else {
                            ie(this.loader);
                            var h = this.elements[n],
                                u = {
                                    index: this.index,
                                    slide: l,
                                    slideNode: l,
                                    slideConfig: h.slideConfig,
                                    slideIndex: this.index,
                                    trigger: h.node,
                                    player: null
                                };
                            this.trigger("slide_before_load", u), h.instance.setContent(l, (function() {
                                ne(e.loader), e.resize(), e.slideAnimateIn(l, r), e.trigger("slide_after_load", u)
                            }))
                        }
                        this.slideDescription = l.querySelector(".gslide-description"), this.slideDescriptionContained = this.slideDescription && C(this.slideDescription.parentNode, "gslide-media"), this.settings.preload && (this.preloadSlide(n + 1), this.preloadSlide(n - 1)), this.updateNavigationClasses(), this.activeSlide = l
                    }
                }, {
                    key: "preloadSlide",
                    value: function(e) {
                        var n = this;
                        if (e < 0 || e > this.elements.length - 1 || X(this.elements[e])) return !1;
                        var r = this.slidesContainer.querySelectorAll(".gslide")[e];
                        if (C(r, "loaded")) return !1;
                        var a = this.elements[e],
                            l = a.type,
                            h = {
                                index: e,
                                slide: r,
                                slideNode: r,
                                slideConfig: a.slideConfig,
                                slideIndex: e,
                                trigger: a.node,
                                player: null
                            };
                        this.trigger("slide_before_load", h), l === "video" || l === "external" ? setTimeout((function() {
                            a.instance.setContent(r, (function() {
                                n.trigger("slide_after_load", h)
                            }))
                        }), 200) : a.instance.setContent(r, (function() {
                            n.trigger("slide_after_load", h)
                        }))
                    }
                }, {
                    key: "prevSlide",
                    value: function() {
                        this.goToSlide(this.index - 1)
                    }
                }, {
                    key: "nextSlide",
                    value: function() {
                        this.goToSlide(this.index + 1)
                    }
                }, {
                    key: "goToSlide",
                    value: function() {
                        var e = arguments.length > 0 && arguments[0] !== void 0 && arguments[0];
                        if (this.prevActiveSlide = this.activeSlide, this.prevActiveSlideIndex = this.index, !this.loop() && (e < 0 || e > this.elements.length - 1)) return !1;
                        e < 0 ? e = this.elements.length - 1 : e >= this.elements.length && (e = 0), this.showSlide(e)
                    }
                }, {
                    key: "insertSlide",
                    value: function() {
                        var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {},
                            n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : -1;
                        n < 0 && (n = this.elements.length);
                        var r = new ve(e, this, n),
                            a = r.getConfig(),
                            l = v({}, a),
                            h = r.create(),
                            u = this.elements.length - 1;
                        l.index = n, l.node = !1, l.instance = r, l.slideConfig = a, this.elements.splice(n, 0, l);
                        var p = null,
                            b = null;
                        if (this.slidesContainer) {
                            if (n > u) this.slidesContainer.appendChild(h);
                            else {
                                var y = this.slidesContainer.querySelectorAll(".gslide")[n];
                                this.slidesContainer.insertBefore(h, y)
                            }(this.settings.preload && this.index == 0 && n == 0 || this.index - 1 == n || this.index + 1 == n) && this.preloadSlide(n), this.index === 0 && n === 0 && (this.index = 1), this.updateNavigationClasses(), p = this.slidesContainer.querySelectorAll(".gslide")[n], b = this.getSlidePlayerInstance(n), l.slideNode = p
                        }
                        this.trigger("slide_inserted", {
                            index: n,
                            slide: p,
                            slideNode: p,
                            slideConfig: a,
                            slideIndex: n,
                            trigger: null,
                            player: b
                        }), I(this.settings.slideInserted) && this.settings.slideInserted({
                            index: n,
                            slide: p,
                            player: b
                        })
                    }
                }, {
                    key: "removeSlide",
                    value: function() {
                        var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : -1;
                        if (e < 0 || e > this.elements.length - 1) return !1;
                        var n = this.slidesContainer && this.slidesContainer.querySelectorAll(".gslide")[e];
                        n && (this.getActiveSlideIndex() == e && (e == this.elements.length - 1 ? this.prevSlide() : this.nextSlide()), n.parentNode.removeChild(n)), this.elements.splice(e, 1), this.trigger("slide_removed", e), I(this.settings.slideRemoved) && this.settings.slideRemoved(e)
                    }
                }, {
                    key: "slideAnimateIn",
                    value: function(e, n) {
                        var r = this,
                            a = e.querySelector(".gslide-media"),
                            l = e.querySelector(".gslide-description"),
                            h = {
                                index: this.prevActiveSlideIndex,
                                slide: this.prevActiveSlide,
                                slideNode: this.prevActiveSlide,
                                slideIndex: this.prevActiveSlide,
                                slideConfig: X(this.prevActiveSlideIndex) ? null : this.elements[this.prevActiveSlideIndex].slideConfig,
                                trigger: X(this.prevActiveSlideIndex) ? null : this.elements[this.prevActiveSlideIndex].node,
                                player: this.getSlidePlayerInstance(this.prevActiveSlideIndex)
                            },
                            u = {
                                index: this.index,
                                slide: this.activeSlide,
                                slideNode: this.activeSlide,
                                slideConfig: this.elements[this.index].slideConfig,
                                slideIndex: this.index,
                                trigger: this.elements[this.index].node,
                                player: this.getSlidePlayerInstance(this.index)
                            };
                        if (a.offsetWidth > 0 && l && (ne(l), l.style.display = ""), x(e, this.effectsClasses), n) z(e, this.settings.cssEfects[this.settings.openEffect].in, (function() {
                            r.settings.autoplayVideos && r.slidePlayerPlay(e), r.trigger("slide_changed", {
                                prev: h,
                                current: u
                            }), I(r.settings.afterSlideChange) && r.settings.afterSlideChange.apply(r, [h, u])
                        }));
                        else {
                            var p = this.settings.slideEffect,
                                b = p !== "none" ? this.settings.cssEfects[p].in : p;
                            this.prevActiveSlideIndex > this.index && this.settings.slideEffect == "slide" && (b = this.settings.cssEfects.slideBack.in), z(e, b, (function() {
                                r.settings.autoplayVideos && r.slidePlayerPlay(e), r.trigger("slide_changed", {
                                    prev: h,
                                    current: u
                                }), I(r.settings.afterSlideChange) && r.settings.afterSlideChange.apply(r, [h, u])
                            }))
                        }
                        setTimeout((function() {
                            r.resize(e)
                        }), 100), w(e, "current")
                    }
                }, {
                    key: "slideAnimateOut",
                    value: function() {
                        if (!this.prevActiveSlide) return !1;
                        var e = this.prevActiveSlide;
                        x(e, this.effectsClasses), w(e, "prev");
                        var n = this.settings.slideEffect,
                            r = n !== "none" ? this.settings.cssEfects[n].out : n;
                        this.slidePlayerPause(e), this.trigger("slide_before_change", {
                            prev: {
                                index: this.prevActiveSlideIndex,
                                slide: this.prevActiveSlide,
                                slideNode: this.prevActiveSlide,
                                slideIndex: this.prevActiveSlideIndex,
                                slideConfig: X(this.prevActiveSlideIndex) ? null : this.elements[this.prevActiveSlideIndex].slideConfig,
                                trigger: X(this.prevActiveSlideIndex) ? null : this.elements[this.prevActiveSlideIndex].node,
                                player: this.getSlidePlayerInstance(this.prevActiveSlideIndex)
                            },
                            current: {
                                index: this.index,
                                slide: this.activeSlide,
                                slideNode: this.activeSlide,
                                slideIndex: this.index,
                                slideConfig: this.elements[this.index].slideConfig,
                                trigger: this.elements[this.index].node,
                                player: this.getSlidePlayerInstance(this.index)
                            }
                        }), I(this.settings.beforeSlideChange) && this.settings.beforeSlideChange.apply(this, [{
                            index: this.prevActiveSlideIndex,
                            slide: this.prevActiveSlide,
                            player: this.getSlidePlayerInstance(this.prevActiveSlideIndex)
                        }, {
                            index: this.index,
                            slide: this.activeSlide,
                            player: this.getSlidePlayerInstance(this.index)
                        }]), this.prevActiveSlideIndex > this.index && this.settings.slideEffect == "slide" && (r = this.settings.cssEfects.slideBack.out), z(e, r, (function() {
                            var a = e.querySelector(".ginner-container"),
                                l = e.querySelector(".gslide-media"),
                                h = e.querySelector(".gslide-description");
                            a.style.transform = "", l.style.transform = "", x(l, "greset"), l.style.opacity = "", h && (h.style.opacity = ""), x(e, "prev")
                        }))
                    }
                }, {
                    key: "getAllPlayers",
                    value: function() {
                        return this.videoPlayers
                    }
                }, {
                    key: "getSlidePlayerInstance",
                    value: function(e) {
                        var n = "gvideo" + e,
                            r = this.getAllPlayers();
                        return !(!H(r, n) || !r[n]) && r[n]
                    }
                }, {
                    key: "stopSlideVideo",
                    value: function(e) {
                        if (Z(e)) {
                            var n = e.querySelector(".gvideo-wrapper");
                            n && (e = n.getAttribute("data-index"))
                        }
                        console.log("stopSlideVideo is deprecated, use slidePlayerPause");
                        var r = this.getSlidePlayerInstance(e);
                        r && r.playing && r.pause()
                    }
                }, {
                    key: "slidePlayerPause",
                    value: function(e) {
                        if (Z(e)) {
                            var n = e.querySelector(".gvideo-wrapper");
                            n && (e = n.getAttribute("data-index"))
                        }
                        var r = this.getSlidePlayerInstance(e);
                        r && r.playing && r.pause()
                    }
                }, {
                    key: "playSlideVideo",
                    value: function(e) {
                        if (Z(e)) {
                            var n = e.querySelector(".gvideo-wrapper");
                            n && (e = n.getAttribute("data-index"))
                        }
                        console.log("playSlideVideo is deprecated, use slidePlayerPlay");
                        var r = this.getSlidePlayerInstance(e);
                        r && !r.playing && r.play()
                    }
                }, {
                    key: "slidePlayerPlay",
                    value: function(e) {
                        var n;
                        if (!je || (n = this.settings.plyr.config) !== null && n !== void 0 && n.muted) {
                            if (Z(e)) {
                                var r = e.querySelector(".gvideo-wrapper");
                                r && (e = r.getAttribute("data-index"))
                            }
                            var a = this.getSlidePlayerInstance(e);
                            a && !a.playing && (a.play(), this.settings.autofocusVideos && a.elements.container.focus())
                        }
                    }
                }, {
                    key: "setElements",
                    value: function(e) {
                        var n = this;
                        this.settings.elements = !1;
                        var r = [];
                        e && e.length && m(e, (function(a, l) {
                            var h = new ve(a, n, l),
                                u = h.getConfig(),
                                p = v({}, u);
                            p.slideConfig = u, p.instance = h, p.index = l, r.push(p)
                        })), this.elements = r, this.lightboxOpen && (this.slidesContainer.innerHTML = "", this.elements.length && (m(this.elements, (function() {
                            var a = se(n.settings.slideHTML);
                            n.slidesContainer.appendChild(a)
                        })), this.showSlide(0, !0)))
                    }
                }, {
                    key: "getElementIndex",
                    value: function(e) {
                        var n = !1;
                        return m(this.elements, (function(r, a) {
                            if (H(r, "node") && r.node == e) return n = a, !0
                        })), n
                    }
                }, {
                    key: "getElements",
                    value: function() {
                        var e = this,
                            n = [];
                        this.elements = this.elements ? this.elements : [], !X(this.settings.elements) && Fe(this.settings.elements) && this.settings.elements.length && m(this.settings.elements, (function(a, l) {
                            var h = new ve(a, e, l),
                                u = h.getConfig(),
                                p = v({}, u);
                            p.node = !1, p.index = l, p.instance = h, p.slideConfig = u, n.push(p)
                        }));
                        var r = !1;
                        return this.getSelector() && (r = document.querySelectorAll(this.getSelector())), r && m(r, (function(a, l) {
                            var h = new ve(a, e, l),
                                u = h.getConfig(),
                                p = v({}, u);
                            p.node = a, p.index = l, p.instance = h, p.slideConfig = u, p.gallery = a.getAttribute("data-gallery"), n.push(p)
                        })), n
                    }
                }, {
                    key: "getGalleryElements",
                    value: function(e, n) {
                        return e.filter((function(r) {
                            return r.gallery == n
                        }))
                    }
                }, {
                    key: "getSelector",
                    value: function() {
                        return !this.settings.elements && (this.settings.selector && this.settings.selector.substring(0, 5) == "data-" ? "*[".concat(this.settings.selector, "]") : this.settings.selector)
                    }
                }, {
                    key: "getActiveSlide",
                    value: function() {
                        return this.slidesContainer.querySelectorAll(".gslide")[this.index]
                    }
                }, {
                    key: "getActiveSlideIndex",
                    value: function() {
                        return this.index
                    }
                }, {
                    key: "getAnimationClasses",
                    value: function() {
                        var e = [];
                        for (var n in this.settings.cssEfects)
                            if (this.settings.cssEfects.hasOwnProperty(n)) {
                                var r = this.settings.cssEfects[n];
                                e.push("g".concat(r.in)), e.push("g".concat(r.out))
                            } return e.join(" ")
                    }
                }, {
                    key: "build",
                    value: function() {
                        var e = this;
                        if (this.built) return !1;
                        var n = document.body.childNodes,
                            r = [];
                        m(n, (function(y) {
                            y.parentNode == document.body && y.nodeName.charAt(0) !== "#" && y.hasAttribute && !y.hasAttribute("aria-hidden") && (r.push(y), y.setAttribute("aria-hidden", "true"))
                        }));
                        var a = H(this.settings.svg, "next") ? this.settings.svg.next : "",
                            l = H(this.settings.svg, "prev") ? this.settings.svg.prev : "",
                            h = H(this.settings.svg, "close") ? this.settings.svg.close : "",
                            u = this.settings.lightboxHTML;
                        u = se(u = (u = (u = u.replace(/{nextSVG}/g, a)).replace(/{prevSVG}/g, l)).replace(/{closeSVG}/g, h)), document.body.appendChild(u);
                        var p = document.getElementById("glightbox-body");
                        this.modal = p;
                        var b = p.querySelector(".gclose");
                        this.prevButton = p.querySelector(".gprev"), this.nextButton = p.querySelector(".gnext"), this.overlay = p.querySelector(".goverlay"), this.loader = p.querySelector(".gloader"), this.slidesContainer = document.getElementById("glightbox-slider"), this.bodyHiddenChildElms = r, this.events = {}, w(this.modal, "glightbox-" + this.settings.skin), this.settings.closeButton && b && (this.events.close = S("click", {
                            onElement: b,
                            withCallback: function(y, E) {
                                y.preventDefault(), e.close()
                            }
                        })), b && !this.settings.closeButton && b.parentNode.removeChild(b), this.nextButton && (this.events.next = S("click", {
                            onElement: this.nextButton,
                            withCallback: function(y, E) {
                                y.preventDefault(), e.nextSlide()
                            }
                        })), this.prevButton && (this.events.prev = S("click", {
                            onElement: this.prevButton,
                            withCallback: function(y, E) {
                                y.preventDefault(), e.prevSlide()
                            }
                        })), this.settings.closeOnOutsideClick && (this.events.outClose = S("click", {
                            onElement: p,
                            withCallback: function(y, E) {
                                e.preventOutsideClick || C(document.body, "glightbox-mobile") || L(y.target, ".ginner-container") || L(y.target, ".gbtn") || C(y.target, "gnext") || C(y.target, "gprev") || e.close()
                            }
                        })), m(this.elements, (function(y, E) {
                            e.slidesContainer.appendChild(y.instance.create()), y.slideNode = e.slidesContainer.querySelectorAll(".gslide")[E]
                        })), We && w(document.body, "glightbox-touch"), this.events.resize = S("resize", {
                            onElement: window,
                            withCallback: function() {
                                e.resize()
                            }
                        }), this.built = !0
                    }
                }, {
                    key: "resize",
                    value: function() {
                        var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
                        if ((e = e || this.activeSlide) && !C(e, "zoomed")) {
                            var n = He(),
                                r = e.querySelector(".gvideo-wrapper"),
                                a = e.querySelector(".gslide-image"),
                                l = this.slideDescription,
                                h = n.width,
                                u = n.height;
                            if (h <= 768 ? w(document.body, "glightbox-mobile") : x(document.body, "glightbox-mobile"), r || a) {
                                var p = !1;
                                if (l && (C(l, "description-bottom") || C(l, "description-top")) && !C(l, "gabsolute") && (p = !0), a) {
                                    if (h <= 768) a.querySelector("img");
                                    else if (p) {
                                        var b, y, E = l.offsetHeight,
                                            T = a.querySelector("img"),
                                            A = (b = this.elements[this.index]) === null || b === void 0 ? void 0 : b.node,
                                            q = "100vh";
                                        A && (q = (y = A.getAttribute("data-height")) !== null && y !== void 0 ? y : q), T.setAttribute("style", "max-height: calc(".concat(q, " - ").concat(E, "px)")), l.setAttribute("style", "max-width: ".concat(T.offsetWidth, "px;"))
                                    }
                                }
                                if (r) {
                                    var _ = H(this.settings.plyr.config, "ratio") ? this.settings.plyr.config.ratio : "";
                                    if (!_) {
                                        var D = r.clientWidth,
                                            W = r.clientHeight,
                                            V = D / W;
                                        _ = "".concat(D / V, ":").concat(W / V)
                                    }
                                    var Q = _.split(":"),
                                        B = this.settings.videosWidth,
                                        J = this.settings.videosWidth,
                                        ee = (J = me(B) || B.indexOf("px") !== -1 ? parseInt(B) : B.indexOf("vw") !== -1 ? h * parseInt(B) / 100 : B.indexOf("vh") !== -1 ? u * parseInt(B) / 100 : B.indexOf("%") !== -1 ? h * parseInt(B) / 100 : parseInt(r.clientWidth)) / (parseInt(Q[0]) / parseInt(Q[1]));
                                    if (ee = Math.floor(ee), p && (u -= l.offsetHeight), J > h || ee > u || u < ee && h > J) {
                                        var ge = r.offsetWidth,
                                            ce = r.offsetHeight,
                                            G = u / ce,
                                            K = {
                                                width: ge * G,
                                                height: ce * G
                                            };
                                        r.parentNode.setAttribute("style", "max-width: ".concat(K.width, "px")), p && l.setAttribute("style", "max-width: ".concat(K.width, "px;"))
                                    } else r.parentNode.style.maxWidth = "".concat(B), p && l.setAttribute("style", "max-width: ".concat(B, ";"))
                                }
                            }
                        }
                    }
                }, {
                    key: "reload",
                    value: function() {
                        this.init()
                    }
                }, {
                    key: "updateNavigationClasses",
                    value: function() {
                        var e = this.loop();
                        x(this.nextButton, "disabled"), x(this.prevButton, "disabled"), this.index == 0 && this.elements.length - 1 == 0 ? (w(this.prevButton, "disabled"), w(this.nextButton, "disabled")) : this.index !== 0 || e ? this.index !== this.elements.length - 1 || e || w(this.nextButton, "disabled") : w(this.prevButton, "disabled")
                    }
                }, {
                    key: "loop",
                    value: function() {
                        var e = H(this.settings, "loopAtEnd") ? this.settings.loopAtEnd : null;
                        return e = H(this.settings, "loop") ? this.settings.loop : e, e
                    }
                }, {
                    key: "close",
                    value: function() {
                        var e = this;
                        if (!this.lightboxOpen) {
                            if (this.events) {
                                for (var n in this.events) this.events.hasOwnProperty(n) && this.events[n].destroy();
                                this.events = null
                            }
                            return !1
                        }
                        if (this.closing) return !1;
                        this.closing = !0, this.slidePlayerPause(this.activeSlide), this.fullElementsList && (this.elements = this.fullElementsList), this.bodyHiddenChildElms.length && m(this.bodyHiddenChildElms, (function(r) {
                            r.removeAttribute("aria-hidden")
                        })), w(this.modal, "glightbox-closing"), z(this.overlay, this.settings.openEffect == "none" ? "none" : this.settings.cssEfects.fade.out), z(this.activeSlide, this.settings.cssEfects[this.settings.closeEffect].out, (function() {
                            if (e.activeSlide = null, e.prevActiveSlideIndex = null, e.prevActiveSlide = null, e.built = !1, e.events) {
                                for (var r in e.events) e.events.hasOwnProperty(r) && e.events[r].destroy();
                                e.events = null
                            }
                            var a = document.body;
                            x(Ue, "glightbox-open"), x(a, "glightbox-open touching gdesc-open glightbox-touch glightbox-mobile gscrollbar-fixer"), e.modal.parentNode.removeChild(e.modal), e.trigger("close"), I(e.settings.onClose) && e.settings.onClose();
                            var l = document.querySelector(".gcss-styles");
                            l && l.parentNode.removeChild(l), e.lightboxOpen = !1, e.closing = null
                        }))
                    }
                }, {
                    key: "destroy",
                    value: function() {
                        this.close(), this.clearAllEvents(), this.baseEvents && this.baseEvents.destroy()
                    }
                }, {
                    key: "on",
                    value: function(e, n) {
                        var r = arguments.length > 2 && arguments[2] !== void 0 && arguments[2];
                        if (!e || !I(n)) throw new TypeError("Event name and callback must be defined");
                        this.apiEvents.push({
                            evt: e,
                            once: r,
                            callback: n
                        })
                    }
                }, {
                    key: "once",
                    value: function(e, n) {
                        this.on(e, n, !0)
                    }
                }, {
                    key: "trigger",
                    value: function(e) {
                        var n = this,
                            r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null,
                            a = [];
                        m(this.apiEvents, (function(l, h) {
                            var u = l.evt,
                                p = l.once,
                                b = l.callback;
                            u == e && (b(r), p && a.push(h))
                        })), a.length && m(a, (function(l) {
                            return n.apiEvents.splice(l, 1)
                        }))
                    }
                }, {
                    key: "clearAllEvents",
                    value: function() {
                        this.apiEvents.splice(0, this.apiEvents.length)
                    }
                }, {
                    key: "version",
                    value: function() {
                        return "3.3.1"
                    }
                }]);
            return function() {
                var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {},
                    n = new Tt(e);
                return n.init(), n
            }
        }))
    })(Se)), Se.exports
}
var li = oi();
const ci = ri(li);
class di {
    constructor() {
        this.lightbox = null, this.initialized = !1
    }
    init(t, i = {}) {
        if (!t) return;
        const o = {
                ...{
                    touchNavigation: !0,
                    loop: !0,
                    autoplayVideos: !1,
                    closeOnOutsideClick: !0,
                    zoomable: !0,
                    draggable: !0,
                    dragToleranceX: 40,
                    dragToleranceY: 65,
                    openEffect: "fade",
                    closeEffect: "fade",
                    cssEffects: {
                        fadeIn: "glightbox-fade-in",
                        fadeOut: "glightbox-fade-out"
                    },
                    svg: {
                        close: '<i class="ph ph-x"></i>',
                        prev: '<i class="ph ph-caret-left"></i>',
                        next: '<i class="ph ph-caret-right"></i>'
                    },
                    plyr: {
                        css: "",
                        js: "",
                        config: {
                            ratio: "16:9",
                            muted: !1,
                            hideControls: !0,
                            youtube: {
                                noCookie: !0,
                                rel: 0,
                                showinfo: 0,
                                iv_load_policy: 3
                            },
                            vimeo: {
                                byline: !1,
                                portrait: !1,
                                title: !1,
                                speed: !0,
                                transparent: !1
                            }
                        }
                    }
                },
                ...i
            },
            c = this.buildElements(t);
        c.length !== 0 && (this.lightbox && this.lightbox.destroy(), this.lightbox = ci({
            elements: c,
            ...o
        }), this.bindClickHandlers(t), this.initialized = !0)
    }
    buildElements(t) {
        const i = t.querySelectorAll("[data-gallery-image]"),
            s = [];
        return i.forEach(o => {
            switch (o.dataset.mediaType) {
                case "image": {
                    const f = o.querySelector("img");
                    if (f) {
                        const g = f.src.replace(/width=\d+/, "width=3000");
                        s.push({
                            href: g,
                            type: "image",
                            alt: f.alt || "",
                            zoomable: !0
                        })
                    }
                    break
                }
                case "video": {
                    const f = o.querySelector("video");
                    if (f) {
                        const g = f.querySelectorAll("source"),
                            m = `<video src="${g.length>0?g[0].src:f.src}" class="glightbox-video" controls playsinline preload="metadata" style="max-width:100%; max-height:80vh;"></video>`;
                        s.push({
                            content: m,
                            type: "inline"
                        })
                    }
                    break
                }
                case "external_video": {
                    const f = o.dataset.externalVideoId,
                        g = o.dataset.externalVideoHost;
                    if (f && g) {
                        let v = "";
                        g === "youtube" ? v = `https://www.youtube.com/watch?v=${f}` : g === "vimeo" && (v = `https://vimeo.com/${f}`), v && s.push({
                            href: v,
                            type: "video",
                            source: g
                        })
                    }
                    break
                }
            }
        }), s
    }
    bindClickHandlers(t) {
        const i = t.querySelectorAll("[data-gallery-image]");
        let s = 0;
        const o = new Map;
        i.forEach(c => {
            c.dataset.mediaType !== "model" && (o.set(c, s), s++)
        }), i.forEach(c => {
            c.dataset.mediaType === "image" && (c.style.cursor = "zoom-in", c.addEventListener("click", g => {
                g.target.closest("button, .model-viewer-ui") || (g.preventDefault(), this.open(o.get(c)))
            }))
        })
    }
    open(t = 0) {
        this.lightbox && this.lightbox.openAt(t)
    }
    close() {
        this.lightbox && this.lightbox.close()
    }
    destroy() {
        this.lightbox && (this.lightbox.destroy(), this.lightbox = null, this.initialized = !1)
    }
    refresh(t, i = {}) {
        this.destroy(), this.init(t, i)
    }
}
const ui = new di;

function it(d, t) {
    try {
        return t !== void 0 ? (localStorage.setItem(d, t), !0) : localStorage.getItem(d)
    } catch {
        return t !== void 0 ? !1 : null
    }
}

function hi(d, t) {
    let i;
    return function(...s) {
        clearTimeout(i), i = setTimeout(() => d.apply(this, s), t)
    }
}
class ae extends HTMLElement {
    constructor() {
        super(), this.boundHandlers = {}
    }
    connectedCallback() {
        this.sectionId = this.dataset.sectionId, this.form = this.querySelector("[data-facets-form]"), this.drawer = this.querySelector("#FacetsDrawer"), this.loading = this.querySelector("[data-facets-loading]"), this.drawer && document.body.appendChild(this.drawer), this.boundHandlers.onFormChange = hi(this.onFormChange.bind(this), ze.search), this.boundHandlers.onActiveFilterClick = this.onActiveFilterClick.bind(this), this.boundHandlers.onKeydown = this.onKeydown.bind(this), this.boundHandlers.onPopState = this.onPopState.bind(this), this.bindEvents(), this.setupHistoryListener()
    }
    disconnectedCallback() {
        document.removeEventListener("keydown", this.boundHandlers.onKeydown), window.removeEventListener("popstate", this.boundHandlers.onPopState), this.drawer && this.drawer.parentNode === document.body && this.drawer.remove()
    }
    bindEvents() {
        this.form && this.form.addEventListener("input", this.boundHandlers.onFormChange);
        const t = this.querySelector("[data-facets-open]");
        t && t.addEventListener("click", () => this.openDrawer()), this.drawer && this.drawer.addEventListener("click", o => {
            (o.target.closest("[data-facets-close]") || o.target.closest("[data-facets-apply]")) && this.closeDrawer();
            const c = o.target.closest("[data-facet-clear-all]");
            if (c) {
                o.preventDefault();
                const f = c.href,
                    g = f.includes("?") ? f.slice(f.indexOf("?") + 1) : "";
                this.renderPage(g), this.closeDrawer()
            }
        }), this.querySelectorAll("[data-facet-remove], [data-facet-clear-all]").forEach(o => {
            o.addEventListener("click", this.boundHandlers.onActiveFilterClick)
        });
        const i = this.querySelector("#SortBy");
        i && i.addEventListener("change", this.boundHandlers.onFormChange);
        const s = this.querySelector("#SortByMobile");
        s && s.addEventListener("change", o => {
            i && (i.value = o.target.value)
        }), document.addEventListener("keydown", this.boundHandlers.onKeydown), this.setupViewToggle()
    }
    setupViewToggle() {
        const t = this.querySelectorAll("[data-view-toggle]"),
            i = document.querySelector("[data-collection-wrapper]");
        if (!t.length || !i) return;
        const s = i.querySelector("[data-collection-content]"),
            o = i.querySelector("[data-collection-list-content]"),
            c = g => {
                i.dataset.view = g, o && (g === "list" ? (s?.classList.add("hidden"), o.classList.remove("hidden")) : (s?.classList.remove("hidden"), o.classList.add("hidden")))
            },
            f = it("collection-view") || "grid";
        c(f), t.forEach(g => {
            const v = g.dataset.viewToggle === f;
            g.classList.toggle("is-active", v), g.setAttribute("aria-pressed", v)
        }), t.forEach(g => {
            g.addEventListener("click", () => {
                const v = g.dataset.viewToggle,
                    m = i.dataset.view;
                if (v === m) return;
                const k = v === "list" ? o : s,
                    S = v === "list" ? s : o,
                    w = typeof window.shouldAnimate == "function" && window.shouldAnimate(),
                    x = window.gsap || window.pieces?.gsap;
                if (t.forEach(C => {
                        const L = C.dataset.viewToggle === v;
                        C.classList.toggle("is-active", L), C.setAttribute("aria-pressed", L)
                    }), w && x && k && S) {
                    const C = S.offsetHeight;
                    x.to(S, {
                        opacity: 0,
                        duration: .2,
                        ease: "power2.in",
                        onComplete: () => {
                            c(v), x.set(k, {
                                opacity: 0
                            });
                            const L = i.querySelector("[data-product-grid-container]");
                            if (L) {
                                L.style.height = `${C}px`, L.style.overflow = "hidden";
                                const z = k.offsetHeight;
                                x.to(L, {
                                    height: z,
                                    duration: .4,
                                    ease: "power3.inOut",
                                    onComplete: () => {
                                        L.style.height = "", L.style.overflow = ""
                                    }
                                })
                            }
                            x.to(k, {
                                opacity: 1,
                                duration: .3,
                                delay: .15,
                                ease: "power2.out",
                                onComplete: () => {
                                    window.pieces?.lenis && window.pieces.lenis.resize()
                                }
                            })
                        }
                    })
                } else c(v), window.pieces?.lenis && window.pieces.lenis.resize();
                it("collection-view", v)
            })
        })
    }
    setupHistoryListener() {
        ae.searchParamsInitial = window.location.search.slice(1), ae.searchParamsPrev = window.location.search.slice(1), window.addEventListener("popstate", this.boundHandlers.onPopState)
    }
    onKeydown(t) {
        t.key === "Escape" && this.isDrawerOpen() && this.closeDrawer()
    }
    onPopState(t) {
        const i = t.state?.searchParams ?? ae.searchParamsInitial;
        i !== ae.searchParamsPrev && this.renderPage(i, !1)
    }
    isDrawerOpen() {
        return this.drawer && !this.drawer.hasAttribute("inert")
    }
    openDrawer() {
        if (!this.drawer) return;
        this.scrollPosition = window.scrollY, document.body.style.top = `-${this.scrollPosition}px`, document.documentElement.classList.add("scroll-locked"), window.pieces?.lenis && window.pieces.lenis.stop(), this.drawer.removeAttribute("inert"), this.drawer.classList.add("is-open");
        const t = this.querySelector("[data-facets-open]");
        t && t.setAttribute("aria-expanded", "true"), requestAnimationFrame(() => {
            const i = this.drawer.querySelector("[data-facets-close]");
            i && i.focus()
        })
    }
    closeDrawer() {
        if (!this.drawer) return;
        this.drawer.classList.remove("is-open"), setTimeout(() => {
            this.drawer.setAttribute("inert", ""), document.documentElement.classList.remove("scroll-locked"), document.body.style.top = "", window.scrollTo(0, this.scrollPosition || 0), window.pieces?.lenis && window.pieces.lenis.start()
        }, Ce.normal);
        const t = this.querySelector("[data-facets-open]");
        t && (t.setAttribute("aria-expanded", "false"), t.focus())
    }
    onFormChange(t) {
        const i = new FormData(this.form),
            s = document.querySelector("#SortBy");
        s && s.value && i.set("sort_by", s.value);
        const o = new URLSearchParams(i).toString();
        this.renderPage(o)
    }
    onActiveFilterClick(t) {
        t.preventDefault();
        const i = t.currentTarget.href,
            s = i.includes("?") ? i.slice(i.indexOf("?") + 1) : "";
        this.renderPage(s)
    }
    async renderPage(t, i = !0) {
        ae.searchParamsPrev = t, this.showLoading();
        try {
            const s = `${window.location.pathname}?section_id=${this.sectionId}&${t}`,
                c = await (await fetch(s)).text(),
                g = new DOMParser().parseFromString(c, "text/html");
            this.updateProductGrid(g), this.updateFilters(g), this.updateActiveFacets(g), this.updateProductCount(g), this.updatePagination(g), i && this.updateURL(t), window.pieces?.lenis && window.pieces.lenis.resize()
        } catch {} finally {
            this.hideLoading()
        }
    }
    updateProductGrid(t) {
        const i = t.querySelector("[data-collection-content]"),
            s = document.querySelector("[data-collection-content]");
        if (i && s) {
            const o = document.querySelector("[data-collection-wrapper]");
            o && o.classList.add("is-transitioning"), s.replaceChildren(...i.cloneNode(!0).childNodes), requestAnimationFrame(() => {
                o && (o.classList.remove("is-transitioning"), this.animateNewItems(s)), document.dispatchEvent(new CustomEvent("facets:updated"))
            })
        }
    }
    animateNewItems(t) {
        const i = t.querySelectorAll("[data-collection-item], [data-product-card]");
        window.pieces?.tween && window.pieces.tween.reinit(), typeof gsap < "u" && i.forEach((s, o) => {
            const c = s.querySelector(".product-card-image"),
                f = s.querySelectorAll(".product-card-title .overflow-hidden span"),
                g = s.querySelectorAll(".product-card-price .overflow-hidden span");
            c && gsap.set(c, {
                clipPath: "inset(0 100% 0 0)"
            }), f.length && gsap.set(f, {
                yPercent: 100
            }), g.length && gsap.set(g, {
                yPercent: 100
            });
            const v = o % 4 * .1;
            gsap.delayedCall(v, () => {
                const m = gsap.timeline();
                c && m.to(c, {
                    clipPath: "inset(0 0% 0 0)",
                    duration: 1.2,
                    ease: "expo.inOut"
                }, 0), f.length && m.to(f, {
                    yPercent: 0,
                    duration: .8,
                    ease: "power4.out",
                    stagger: .05
                }, .2), g.length && m.to(g, {
                    yPercent: 0,
                    duration: .6,
                    ease: "power4.out",
                    stagger: .05
                }, .3)
            })
        })
    }
    updateFilters(t) {
        const i = t.querySelector(".facets-drawer__filters"),
            s = this.drawer?.querySelector(".facets-drawer__filters");
        if (i && s) {
            const o = [...s.querySelectorAll("details[open]")].map(c => c.id);
            s.replaceChildren(...i.cloneNode(!0).childNodes), o.forEach(c => {
                const f = s.querySelector(`#${c}`);
                f && (f.open = !0)
            }), s.querySelectorAll(".facets-disclosure").forEach(c => {
                c.addEventListener("toggle", () => {
                    const f = c.querySelector(".ph-caret-down");
                    f && (f.style.transform = c.open ? "rotate(180deg)" : "")
                })
            })
        }
    }
    updateActiveFacets(t) {
        const i = t.querySelector("#ActiveFacets"),
            s = this.querySelector("#ActiveFacets");
        i && s && (s.outerHTML = i.outerHTML, this.querySelectorAll("[data-facet-remove], [data-facet-clear-all]").forEach(c => {
            c.addEventListener("click", this.boundHandlers.onActiveFilterClick)
        }));
        const o = this.querySelector("[data-facets-open]");
        if (o) {
            const c = t.querySelector("[data-facets-open]");
            c && o.replaceChildren(...c.cloneNode(!0).childNodes)
        }
    }
    updateProductCount(t) {
        const i = t.querySelector("#ProductCount"),
            s = this.querySelector("#ProductCount");
        i && s && s.replaceChildren(...i.cloneNode(!0).childNodes)
    }
    updatePagination(t) {
        const i = t.querySelector("[data-pagination-load-more]"),
            s = document.querySelector("[data-pagination-load-more]");
        s && (i ? s.replaceChildren(...i.cloneNode(!0).childNodes) : s.replaceChildren());
        const o = t.querySelector(".collection-wrapper nav"),
            c = document.querySelector(".collection-wrapper nav");
        c && o ? c.replaceChildren(...o.cloneNode(!0).childNodes) : c && !o && c.remove()
    }
    updateURL(t) {
        const i = new URLSearchParams(t);
        i.delete("section_id");
        const s = i.toString(),
            o = s ? `${window.location.pathname}?${s}` : window.location.pathname;
        history.pushState({
            searchParams: s
        }, "", o)
    }
    showLoading() {
        this.loading && (this.loading.style.opacity = "1", this.loading.style.pointerEvents = "auto")
    }
    hideLoading() {
        this.loading && (this.loading.style.opacity = "0", this.loading.style.pointerEvents = "none")
    }
}
customElements.get("facet-filters-form") || customElements.define("facet-filters-form", ae);
P.registerPlugin(j, $e, he);
window.gsap = P;
window.Flip = $e;
window.SplitText = he;
window.Lenis = Me;

function Te() {
    ue.init()
}

function ut() {
    window._articleProgressCleanup && (window._articleProgressCleanup(), window._articleProgressCleanup = null);
    const d = document.getElementById("article-progress"),
        t = document.getElementById("article-progress-bar"),
        i = document.querySelector("[data-article-wrapper]");
    if (!d || !t) return;
    if (!i) {
        d.style.display = "none", t.style.width = "0%";
        return
    }
    d.style.display = "block", t.style.width = "0%";
    let s = !1;

    function o() {
        return window.pieces && window.pieces.lenis && window.pieces.lenis.lenis ? window.pieces.lenis.lenis.scroll : window.scrollY
    }

    function c() {
        if (s) return;
        const S = o(),
            w = i.getBoundingClientRect(),
            x = S + w.top,
            C = i.offsetHeight,
            L = window.innerHeight,
            z = x,
            N = x + C - L,
            ie = S;
        let ne = 0;
        ie >= z && ie <= N ? ne = (ie - z) / (N - z) * 100 : ie > N && (ne = 100), t.style.width = `${Math.min(100,Math.max(0,ne))}%`
    }
    let f = null;

    function g() {
        if (window.pieces && window.pieces.lenis && window.pieces.lenis.lenis) {
            const S = window.pieces.lenis.lenis;
            return f = () => c(), S.on("scroll", f), !0
        }
        return !1
    }
    if (!g()) {
        let x = function() {
                if (!s) {
                    if (g()) {
                        c();
                        return
                    }
                    S++, S < w && setTimeout(x, 100)
                }
            },
            S = 0;
        const w = 50;
        x()
    }
    let v = !1;

    function m() {
        v || (requestAnimationFrame(() => {
            c(), v = !1
        }), v = !0)
    }
    window.addEventListener("scroll", m, {
        passive: !0
    }), c();

    function k() {
        s = !0, window.removeEventListener("scroll", m), f && window.pieces && window.pieces.lenis && window.pieces.lenis.lenis && window.pieces.lenis.lenis.off("scroll", f), d && (d.style.display = "none"), t && (t.style.width = "0%")
    }
    window._articleProgressCleanup = k
}

function pi() {
    const d = () => {
        requestAnimationFrame(() => {
            typeof window.shouldAnimate == "function" && window.shouldAnimate() && (ue.reinit(), Te(), j.refresh()), de.reinit(), Ie.reinit()
        })
    };
    document.fonts && document.fonts.ready ? document.fonts.ready.then(d) : d()
}

function gi() {
    setTimeout(() => {
        ut()
    }, 100)
}

function fi() {
    document.addEventListener("menu:open", () => {
        U.stop()
    }), document.addEventListener("menu:close", () => {
        U.start()
    })
}

function nt() {
    const d = window.matchMedia("(prefers-reduced-motion: reduce)").matches,
        t = window.themeSettings?.enableSmoothScroll !== !1;
    !d && t && U.init();
    const i = window.themeSettings?.enablePageTransitions !== !1;
    !d && i && (_e.init(), window.addEventListener("swup:contentReplaced", pi), window.addEventListener("swup:transitionEnd", gi));
    const s = window.themeSettings?.enableAnimations !== !1;
    !d && s && (document.fonts && document.fonts.ready ? document.fonts.ready.then(() => {
        requestAnimationFrame(() => {
            Te(), j.refresh()
        })
    }) : requestAnimationFrame(() => {
        Te()
    })), requestAnimationFrame(() => {
        ut()
    }), fi(), M.init(), M.subscribe(o => {
        o && document.querySelectorAll("[data-cart-count]").forEach(c => {
            c.textContent = o.item_count, c.classList.toggle("hidden", o.item_count === 0)
        })
    }), de.init(), Ie.init(), document.addEventListener("cart:updated", () => {
        _e.clearCache("/cart")
    }), document.addEventListener("cart:refresh", () => {
        M.fetch()
    }), document.addEventListener("click", o => {
        const c = o.target.closest('a[href^="#"]');
        if (c && c.getAttribute("href").length > 1) {
            o.preventDefault();
            const f = document.querySelector(c.getAttribute("href"));
            f && U.scrollTo(f, {
                offset: -100
            })
        }
    }), window.pieces = {
        lenis: U,
        swup: _e,
        tween: ue,
        cartState: M,
        cartDrawer: de,
        cartPage: Ie,
        lightbox: ui,
        gsap: P,
        ScrollTrigger: j,
        Flip: $e,
        SplitText: he,
        Lenis: Me
    }, window.openCartDrawer = () => de.open(), window.closeCartDrawer = () => de.close(), window.refreshCartDrawer = () => de.refresh()
}
document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", nt) : nt();
window.Shopify && window.Shopify.designMode && (document.addEventListener("shopify:section:load", () => {
    typeof window.shouldAnimate == "function" && window.shouldAnimate() && (ue.reinit(), Te())
}), document.addEventListener("shopify:section:unload", () => {
    ue.destroy()
}), document.addEventListener("shopify:section:reorder", () => {
    typeof window.shouldAnimate == "function" && window.shouldAnimate() && ue.refresh()
}));